<template>
  <div>
    <v-dialog
      v-model="dialog_member"
      :lazy="true"
      persistent
      max-width="1060px"
    >
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-layout row wrap>
          <v-flex sm12 md12>
            <v-card>
              <v-card-title>
                <span class="headline"
                  >{{
                    user && user.customer_id ? "Editar" : "Inscrever"
                  }}
                  Membro</span
                >
                <v-spacer />
                <span style="padding-right: 10px">{{
                  user ? user.customer_id : ""
                }}</span>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon left @click="clearUser" v-on="on">refresh</v-icon>
                  </template>
                  <span>Limpar cache</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon left @click="backQueue" v-on="on"
                      >swipe_left</v-icon
                    >
                  </template>
                  <span>Voltar para a Fila</span>
                </v-tooltip>
              </v-card-title>
              <v-card-text>
                <v-alert
                  v-if="user && user.customer_id && user.signedcontract_at"
                  :value="true"
                  type="warning"
                >
                  <p v-html="assinou" />
                </v-alert>
                <v-alert v-if="cpf_duplicated" :value="true" type="warning">
                  <p v-html="cpf_duplicated_msg" />
                </v-alert>
                <v-alert v-if="financial_pending" :value="true" type="error">
                  <p v-html="financial_pending" />
                </v-alert>
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex xs12 sm12>
                      <div class="font-weight-bold">Proposta</div>
                    </v-flex>
                    <v-flex xs12 sm6 md4 lg3>
                      <v-text-field
                        label="E-mail"
                        v-model="email"
                        read-only
                        hint="E-mail principal do membro"
                        :rules="[
                          (v) => !!v || 'Por favor, informe o email',
                          (v) =>
                            /^(([^<>()\[\]\\.,;:\s@&quot;]+(\.[^<>()\[\]\\.,;:\s@&quot;]+)*)|(&quot;.+&quot;))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/.test(
                              v,
                            ) || 'E-mail precisa ser válido',
                        ]"
                        name="email"
                        :disabled="user.customer_id ? true : false"
                        type="email"
                        required
                        @click:append="buscaMember(email, 'email')"
                        append-icon="autorenew"
                        @change="buscaMember($event, 'email')"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md4 lg3>
                      <v-select
                        label="Concessionária*"
                        :items="utilityCompanies"
                        item-value="id"
                        item-text="name"
                        v-model="utility_company"
                        required
                      ></v-select>
                    </v-flex>
                    <v-flex xs12 sm6 md6 lg2>
                      <v-select
                        :items="person_type_items"
                        item-value="value"
                        item-text="text"
                        label="Entidade*"
                        v-model="person_type"
                        :rules="[(v) => !!v || 'Por favor, informe o tipo']"
                        required
                      ></v-select>
                    </v-flex>
                    <v-flex xs12 sm6 md3 lg3>
                      <v-text-field
                        id="cpf"
                        v-model="cpf"
                        autofocus
                        :label="person_type === 'pf' ? 'CPF' : 'CNPJ'"
                        :mask="
                          person_type === 'pf'
                            ? '###.###.###-##'
                            : '##.###.###/####-##'
                        "
                        append-icon="launch"
                        @click:append="show_dialog_ucs"
                        @click:append-outer="
                          buscaDadosComplementares(cpf, false)
                        "
                        append-outer-icon="autorenew"
                        :rules="
                          person_type === 'pf'
                            ? [
                                (v) =>
                                  (v && v.length >= 11) ||
                                  'Preencha o CPF Completo',
                                (v) =>
                                  this.validaCPF(this.cpf) === true ||
                                  'CPF inválido',
                              ]
                            : [
                                (v) =>
                                  v.length >= 14 || 'Preencha o CNPJ Completo',
                                (v) =>
                                  this.validaCNPJ(this.cpf) === true ||
                                  'CNPJ inválido',
                              ]
                        "
                        @change="buscaDadosComplementares($event, true)"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6>
                      <v-text-field
                        :label="
                          'Nome Completo' +
                          (person_type === 'pj'
                            ? ' do Representante Legal'
                            : '')
                        "
                        v-model="name"
                        type="text"
                        required
                        :hint="nome_titular"
                        :rules="[
                          (v) => !!v || 'Por favor, informe o seu nome',
                          (v) =>
                            v.length >= 10 ||
                            'Por favor, preencha o nome completo.',
                        ]"
                      ></v-text-field>
                      <input
                        type="hidden"
                        name="nome_titular"
                        v-model="nome_titular"
                      />
                    </v-flex>
                    <v-flex xs12 sm6>
                      <v-text-field
                        type="tel"
                        v-model="phone"
                        :rules="[
                          (v) => !!v || 'Por favor, informe o celular',
                          (v) =>
                            v.length > 10 ||
                            'Ops. Parece que esse não é um número de telefone',
                        ]"
                        prepend-icon="phone"
                        @click:prepend="call(phone)"
                        append-outer-icon="add"
                        @click:append-outer="dialog_phones = true"
                        return-masked-value
                        mask="(##)#####-####"
                        label="Telefone"
                        hint="Preferencialmente um telefone com whatsapp"
                        persistent-hint
                        required
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm4 md4>
                      <v-text-field
                        label="Média de Consumo"
                        v-model.number="average"
                        name="average"
                        :rules="[
                          (v) => !!v || 'Por favor, informe a média de consumo',
                        ]"
                        required
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs1 sm1 md1 v-if="indicator_name">
                      <v-icon color="green" small>check_circle</v-icon>
                    </v-flex>
                    <v-flex xs12 sm4 md4>
                      <v-text-field
                        v-model="cupom"
                        label="Cupom de desconto (Opcional)"
                        prepend-icon="mdi-sale"
                        name="cupom"
                        required
                        filled
                        rounded
                        dense
                        ref="cupom"
                        @keyup="uppercaseCoupon"
                        @keypress="clearCupom"
                        @keydown="clearCupom"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm3 md1>
                      <v-btn
                        color="indigo"
                        small
                        @click="validateCupom(cupom)"
                        :loading="loadingCupom"
                        :disabled="disabledCupom"
                      >
                        Aplicar
                      </v-btn>
                    </v-flex>

                    <v-flex xs12 sm12 md12 v-if="utility_company !== 'cemig'">
                      <v-combobox
                        v-model="ucs"
                        :filter="filter"
                        :hide-no-data="!search"
                        :items="items"
                        :search-input.sync="search"
                        hide-selected
                        label="CÓDIGO DO CLIENTE"
                        multiple
                        small-chips
                        solo
                        :disabled="!cpf || cpf.trim() === ''"
                        @change="callQualification"
                      >
                        <template v-slot:no-data>
                          <v-list-tile>
                            <span class="subheading">[Enter] Criar</span>
                            <v-chip
                              :color="`${colors_uc[nonce - 1]} lighten-3`"
                              label
                              small
                            >
                              {{ search }}
                            </v-chip>
                          </v-list-tile>
                        </template>
                        <template v-slot:selection="{ item, parent, selected }">
                          <v-chip
                            v-if="item === Object(item)"
                            :color="`${item.color} lighten-3`"
                            :selected="selected"
                            label
                            small
                          >
                            <span class="pr-2">
                              {{ item.text }}
                            </span>
                            <v-icon small @click="parent.selectItem(item)">
                              close
                            </v-icon>
                          </v-chip>
                        </template>
                        <template v-slot:item="{ index, item }">
                          <v-list-tile-content>
                            <v-text-field
                              v-if="editing === item"
                              v-model="editing.text"
                              autofocus
                              flat
                              background-color="transparent"
                              hide-details
                              solo
                              @keyup.enter="edit(index, item)"
                            >
                            </v-text-field>
                            <v-chip
                              v-else
                              :color="`${item.color} lighten-3`"
                              dark
                              label
                              small
                            >
                              {{ item.text }}
                            </v-chip>
                          </v-list-tile-content>
                          <v-spacer></v-spacer>
                          <v-list-tile-action @click.stop>
                            <v-btn icon @click.stop.prevent="edit(index, item)">
                              <v-icon>{{
                                editing !== item ? "edit" : "check"
                              }}</v-icon>
                            </v-btn>
                          </v-list-tile-action>
                        </template>
                      </v-combobox>
                    </v-flex>

                    <v-flex
                      xs12
                      sm12
                      md12
                      v-if="qualifications && qualifications.length > 0"
                    >
                      <v-list three-line>
                        <template
                          v-for="(qualification, idx) in qualifications"
                        >
                          <qualifying-card
                            :key="idx"
                            :qualification="qualification"
                            :installations_found="ucs_cemig"
                            v-if="qualification.status === 'pending'"
                          />
                          <not-qualified-card
                            :key="idx"
                            :qualification="qualification"
                            :installations_found="ucs_cemig"
                            v-if="
                              qualification.status === 'bill_not_found' ||
                              qualification.status === 'error'
                            "
                          />
                          <disqualified-card
                            :key="idx"
                            :qualification="qualification"
                            :installations_found="ucs_cemig"
                            v-if="qualification.status === 'disqualified'"
                          />
                          <qualified-card
                            :key="idx"
                            :qualification="qualification"
                            :installations_found="ucs_cemig"
                            v-if="qualification.status === 'qualified'"
                          />
                        </template>
                      </v-list>
                    </v-flex>

                    <v-layout row wrap v-if="ucs_list">
                      <v-flex xs12>
                        <p class="font-weight-bold">
                          Esse cliente já possui unidades consumidoras
                          cadastradas.
                        </p>
                      </v-flex>
                      <v-flex v-for="list in ucs_list" :key="list.id">
                        <v-card max-width="310">
                          <v-card-title>
                            <v-flex xs2>
                              <v-icon large left> home </v-icon>
                            </v-flex>
                            <v-flex xs5>
                              <span class="title font-weight-light">{{
                                list.id
                              }}</span>
                            </v-flex>
                            <v-flex>
                              <v-tooltip
                                bottom
                                v-if="
                                  list.status === 'canceling' ||
                                  list.status === 'canceled'
                                "
                              >
                                <template v-slot:activator="{ on }">
                                  <v-btn
                                    small
                                    dark
                                    round
                                    :color="list.status | formatUCStatusColor"
                                    v-on="on"
                                  >
                                    <strong>{{
                                      list.status | formatUCStatus
                                    }}</strong>
                                  </v-btn>
                                </template>
                                <span
                                  v-if="
                                    list.status_reason ||
                                    list.status_reason_description
                                  "
                                  ><br />
                                  <div v-if="list.canceled_at">
                                    <strong>Cancelado em: </strong
                                    >{{ list.canceled_at | formatarDate }}
                                    <br /><br />
                                  </div>
                                  <strong>Motivo: </strong
                                  >{{ list.status_reason | formatStatusReason
                                  }}<br /><br />
                                  <strong>Descrição: </strong
                                  >{{ list.status_reason_description }}
                                </span>
                                <span v-else
                                  >Motivo: {{ list.bot_status }}</span
                                >
                              </v-tooltip>
                              <v-btn
                                small
                                dark
                                round
                                :color="list.status | formatUCStatusColor"
                                v-else
                              >
                                <strong>{{
                                  list.status | formatUCStatus
                                }}</strong>
                              </v-btn>
                            </v-flex>
                          </v-card-title>
                          <v-card-text>
                            <p class="font-weight-bold subtitle">
                              {{ list.name }}
                            </p>
                            <p
                              class="caption"
                              v-if="list.address && list.address.address"
                            >
                              {{ list.address.address }},
                              {{ list.address.address_number }},
                              {{ list.address.district }},
                              {{ list.address.city }}/{{
                                list.address.state.initials
                              }}
                              - CEP: {{ list.address.postal_code }}
                            </p>
                          </v-card-text>
                        </v-card>
                      </v-flex>
                      <v-flex xs12>
                        <v-btn
                          dark
                          @click.prevent="buscaDadosComplementares(cpf, false)"
                          >Adicionar Unidades Consumidoras</v-btn
                        >
                      </v-flex>
                      <v-flex xs12>
                        <v-alert
                          v-if="
                            ucs_list &&
                            ucs_list.length > 0 &&
                            status === 'ATIVO'
                          "
                          :value="true"
                          type="warning"
                        >
                          <p
                            v-html="
                              'Só é possivel adicionar novas unidades consumidoras. Para reativar unidades já cadastradas é necessário fazer pela tela de Clientes.'
                            "
                          />
                        </v-alert>
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                      <v-flex xs12>
                        <div class="font-weight-bold">Adição Manual de UC</div>
                      </v-flex>
                      <v-flex xs12 sm6 md6 lg2>
                        <v-select
                          :items="person_type_items"
                          item-value="value"
                          item-text="text"
                          label="Entidade*"
                          v-model="uc_person_type"
                          :rules="[(v) => !!v || 'Por favor, informe o tipo']"
                          required
                        ></v-select>
                      </v-flex>
                      <v-flex xs12 sm6 md4 lg3>
                        <v-select
                          label="Concessionária*"
                          :items="utilityCompanies"
                          item-value="id"
                          item-text="name"
                          v-model="utility_company"
                          required
                        ></v-select>
                      </v-flex>
                      <v-flex xs12 sm6 md3 lg3>
                        <v-text-field
                          id="cpf"
                          v-model="cpf"
                          autofocus
                          :label="person_type === 'pf' ? 'CPF' : 'CNPJ'"
                          :mask="
                            person_type === 'pf'
                              ? '###.###.###-##'
                              : '##.###.###/####-##'
                          "
                          :rules="
                            person_type === 'pf'
                              ? [
                                  (v) =>
                                    v.length >= 11 || 'Preencha o CPF Completo',
                                  (v) =>
                                    this.validaCPF(this.cpf) === true ||
                                    'CPF inválido',
                                ]
                              : [
                                  (v) =>
                                    v.length >= 14 ||
                                    'Preencha o CNPJ Completo',
                                  (v) =>
                                    this.validaCNPJ(this.cpf) === true ||
                                    'CNPJ inválido',
                                ]
                          "
                          @change="buscaDadosComplementares($event, true)"
                        ></v-text-field>
                      </v-flex>
                      <v-select
                        label="Plano da UC*"
                        :items="uc_plans"
                        item-value="value"
                        item-text="text"
                        v-model="uc_utility_company"
                        required
                      ></v-select>

                      <v-flex xs12 md2>
                        <v-text-field
                          id="customer_number"
                          :rules="notEmptyRule"
                          v-model="uc_customer_number"
                          label="Número Cliente"
                          required
                        >
                        </v-text-field>
                      </v-flex>
                      <v-flex xs12 md2>
                        <v-text-field
                          id="installation_number"
                          label="Número de Instalação"
                          :rules="
                            this.consumerunit.utility_company === 'cemig'
                              ? installationNumberRule
                              : notEmptyRule
                          "
                          required
                          @change="validaUnidadeConsumidora($event)"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 md2>
                        <v-combobox
                          id="rate_class"
                          :items="rate_classes"
                          label="Classe"
                          required
                          :rules="[
                            (v) =>
                              !!v ||
                              'Por favor, selecione a classe da instalação!',
                          ]"
                        ></v-combobox>
                      </v-flex>
                      <v-flex xs12 md2>
                        <v-combobox
                          id="subclass"
                          v-model="sub_class"
                          label="Sub Classe"
                          required
                          :items="sub_classes"
                          :rules="[
                            (v) =>
                              !!v ||
                              'Por favor, selecione a sub classe da instalação!',
                          ]"
                        ></v-combobox>
                      </v-flex>
                      <v-flex xs12 md2>
                        <v-text-field
                          id="tarifa"
                          v-model.number="fare_amount"
                          label="Tarifa Base"
                          type="number"
                          :rules="notEmptyRule"
                          required
                        ></v-text-field>
                      </v-flex>
                    </v-layout>

                    <v-flex xs12 sm3 md2>
                      <v-text-field
                        id="cep"
                        v-model="cep"
                        label="CEP"
                        mask="#####-###"
                        :rules="[
                          (v) =>
                            v.length > 7 ||
                            'Ops. Parece que esse não é um CEP válido',
                        ]"
                        @change="buscaCep($event)"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm1 md1>
                      <v-progress-circular
                        v-if="loading_cep"
                        indeterminate
                        color="primary"
                      ></v-progress-circular>
                    </v-flex>
                    <v-flex xs12 sm8 md5>
                      <v-text-field
                        id="logradouro"
                        v-model="logradouro"
                        label="Logradouro"
                        hint="opcional"
                      >
                      </v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md1>
                      <v-text-field
                        id="numero"
                        v-model="numero"
                        label="Número"
                        hint="opcional"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md2>
                      <v-text-field
                        id="complemento"
                        v-model="complemento"
                        label="Complemento"
                        hint="opcional"
                      >
                      </v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md3>
                      <v-text-field
                        id="bairro"
                        v-model="bairro"
                        label="Bairro"
                        hint="opcional"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md3>
                      <v-text-field
                        id="localidade"
                        v-model="localidade"
                        label="Cidade"
                        hint="opcional"
                      >
                      </v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md3>
                      <v-autocomplete
                        :items="states"
                        item-text="name"
                        item-value="initials"
                        label="Estado"
                        prepend-icon="map"
                        v-model="state"
                        return-object
                        :rules="[
                          (v) => !!v || 'Por favor, selecione o seu estado!',
                        ]"
                        hint="Selecione o estado"
                        required
                      ></v-autocomplete>
                    </v-flex>

                    <v-flex xs12 md12>
                      <v-flex xs12>
                        <div class="font-weight-bold">Histórico de consumo</div>
                      </v-flex>
                      <table>
                        <tr>
                          <th
                            v-for="(history, index) in consumerunit.history"
                            :key="index"
                          ></th>
                          <td>
                            <v-text-field
                              v-model.lazy="history.mes_ano"
                              required
                            ></v-text-field>
                          </td>
                          <td>
                            <v-text-field
                              v-model.number="history.consumo"
                              type="number"
                              required
                            >
                            </v-text-field>
                          </td>
                        </tr>
                      </table>
                    </v-flex>
                    <v-btn
                      class="mx-2 font-weight-light"
                      color="success"
                      :loading="loading"
                      :disabled="!valid || loading"
                      @click.prevent="createQualification"
                    >
                      <v-icon left dark>rule</v-icon>
                      Iniciar Qualificação
                    </v-btn>

                    <v-container pa-0 v-if="average > 0">
                      <v-layout row wrap>
                        <v-flex xs12>
                          <div class="font-weight-bold">Planos disponíveis</div>
                        </v-flex>
                        <v-flex
                          v-for="plan in plansEconomySort"
                          :key="plan.id"
                          xs6
                          sm4
                          md4
                          lg4
                        >
                          <v-card
                            @click.prevent="choosePlan(plan)"
                            class="ma-1 card_border"
                            hover
                            :style="
                              selected_plan && selected_plan.id === plan.id
                                ? 'border: 1px solid blue;'
                                : 'border: 1px solid #c0c0c0;'
                            "
                          >
                            <v-flex xs12 class="pa-0 ma-0">
                              <div style="background: #efefef">
                                <v-icon
                                  size="36px"
                                  left
                                  color="blue"
                                  v-if="
                                    selected_plan &&
                                    selected_plan.id === plan.id
                                  "
                                >
                                  check_circle
                                </v-icon>
                              </div>
                              <h4
                                class="pa-2 mt-0 mb-0 text-xs-center font-weight-bold"
                                style="background: #efefef"
                              >
                                {{ plan.name }}
                              </h4>
                              <div
                                class="body-3 pt-1 mt-0 mb-0 blue--text text-xs-center font-weight-bold"
                                style="
                                  border-bottom-width: 2px;
                                  border-bottom-style: solid;
                                  border-bottom-color: #efefef;
                                "
                              >
                                {{ plan.discount }}% de desconto
                              </div>
                              <h5 class="pt-0 pb-0 mb-1 mt-2 text-xs-center">
                                Economize até
                              </h5>
                              <div
                                class="pt-0 text-xs-center display-1 text-no-wrap"
                              >
                                <small class="body-1">R$ </small
                                >{{ plan.economy_year | formatCurrency
                                }}<small class="body-1"> ao ano</small>
                              </div>
                            </v-flex>
                            <v-layout xs6 class="text--center justify-center">
                              <div
                                class="body-2 px-4 py-1 black--text text-xs-center"
                                style="background: #efefef; border-radius: 10px"
                              >
                                R$
                                <span class="font-weight-bold text-xs-center">{{
                                  plan.economy_mounth | formatCurrency
                                }}</span>
                                por mês
                              </div>
                            </v-layout>
                            <plan-conditions :plan="plan" />
                          </v-card>
                        </v-flex>
                      </v-layout>
                    </v-container>
                    <v-layout
                      md8
                      align-center
                      justify-space-between
                      fill-height
                      row
                      v-if="user && user.customer_id"
                    >
                      <v-flex xs4 sm8 md8>
                        <v-text-field
                          v-model="cupom"
                          label="Cupom de desconto (Opcional)"
                          prepend-icon="mdi-sale"
                          name="cupom"
                          required
                          filled
                          rounded
                          dense
                          ref="cupom"
                          @keyup="uppercaseCoupon"
                          @keypress="clearCupom"
                          @keydown="clearCupom"
                        ></v-text-field>
                      </v-flex>

                      <v-flex xs2 sm4 md4>
                        <v-btn
                          color="indigo"
                          small
                          @click="validateCupom(cupom)"
                          :loading="loadingCupom"
                          :disabled="disabledCupom"
                        >
                          Aplicar
                        </v-btn></v-flex
                      >
                    </v-layout>
                    <v-flex
                      xs12
                      sm3
                      md4
                      v-if="psellers && user && user.customer_id"
                    >
                      <v-autocomplete
                        :items="psellers"
                        item-text="name"
                        item-value="email"
                        label="Vendido por"
                        v-model="signedcontract_partner"
                        hint="opcional"
                      ></v-autocomplete>
                    </v-flex>
                    <v-flex xs6 sm12 md12 v-if="user && user.customer_id">
                      <div
                        v-if="!isValidCoupon && couponMessage"
                        class="red--text font-weight-bold"
                      >
                        {{ couponMessage }}
                      </div>
                      <div
                        v-else-if="isValidCoupon && couponMessage"
                        class="green--text font-weight-bold"
                      >
                        {{ couponMessage }}
                      </div>
                    </v-flex>

                    <v-layout
                      row
                      wrap
                      v-if="
                        !(ucs_list && ucs_list.length > 0 && status === 'ATIVO')
                      "
                    >
                      <v-flex xs12 sm12>
                        <div class="font-weight-bold">Dados Pessoais</div>
                      </v-flex>
                      <v-flex xs12 sm9 md12 v-if="person_type === 'pj'">
                        <v-text-field
                          label="Razão Social"
                          v-model="company_name"
                          type="text"
                          required
                          :rules="[
                            (v) =>
                              !!v ||
                              'Por favor, informe a razão social da empresa',
                          ]"
                        >
                        </v-text-field>
                      </v-flex>

                      <v-flex xs12 sm6 md4 v-if="person_type === 'pj'">
                        <v-text-field
                          id="cpf_legal_responsible"
                          v-model="cpf_legal_responsible"
                          autofocus
                          label="CPF do Representante Legal"
                          :mask="'###.###.###-##'"
                          :rules="[
                            (v) =>
                              !!v ||
                              'Por favor, informe o CPF do representante legal da empresa!',
                            (v) => v.length >= 11 || 'Preencha o CPF Completo',
                            (v) =>
                              this.validaCPF(this.cpf_legal_responsible) ===
                                true || 'CPF inválido',
                          ]"
                          required
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6 md2 v-if="person_type === 'pf'">
                        <v-text-field
                          id="rg"
                          v-model="rg"
                          label="Documento"
                          hint="RG ou outro oficial"
                          :rules="[
                            (v) =>
                              v.length > 7 ||
                              'Ops. Parece que esse não é um número valido',
                          ]"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6 md2 v-if="person_type === 'pf'">
                        <v-text-field
                          id="orgao_expeditor"
                          v-model="orgao_expeditor"
                          label="Orgão Expeditor"
                          hint="ex. SSP/MG"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm3 md4 v-if="person_type === 'pf'">
                        <v-select
                          :items="['M', 'F']"
                          label="Sexo"
                          v-model="gender"
                        ></v-select>
                      </v-flex>
                      <v-flex xs12 sm6 md4 v-if="person_type === 'pf'">
                        <v-text-field
                          label="Data de Nasc"
                          v-model="birthday"
                          mask="##/##/####"
                          :rules="[
                            (v) =>
                              v.length > 9 ||
                              'Ops. Parece que esse não é um data válida',
                          ]"
                          return-masked-value
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm3 md2>
                        <v-text-field
                          id="cep"
                          v-model="cep"
                          label="CEP"
                          mask="#####-###"
                          :rules="[
                            (v) =>
                              v.length > 7 ||
                              'Ops. Parece que esse não é um CEP válido',
                          ]"
                          @change="buscaCep($event)"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm1 md1>
                        <v-progress-circular
                          v-if="loading_cep"
                          indeterminate
                          color="primary"
                        ></v-progress-circular>
                      </v-flex>
                      <v-flex xs12 sm8 md5>
                        <v-text-field
                          id="logradouro"
                          v-model="logradouro"
                          label="Logradouro"
                          hint="opcional"
                        >
                        </v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6 md1>
                        <v-text-field
                          id="numero"
                          v-model="numero"
                          label="Número"
                          hint="opcional"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6 md2>
                        <v-text-field
                          id="complemento"
                          v-model="complemento"
                          label="Complemento"
                          hint="opcional"
                        >
                        </v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6 md3>
                        <v-text-field
                          id="bairro"
                          v-model="bairro"
                          label="Bairro"
                          hint="opcional"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6 md3>
                        <v-text-field
                          id="localidade"
                          v-model="localidade"
                          label="Cidade"
                          hint="opcional"
                        >
                        </v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6 md3>
                        <v-autocomplete
                          :items="states"
                          item-text="name"
                          item-value="initials"
                          label="Estado"
                          prepend-icon="map"
                          v-model="state"
                          return-object
                          :rules="[
                            (v) => !!v || 'Por favor, selecione o seu estado!',
                          ]"
                          hint="Selecione o estado"
                          required
                        ></v-autocomplete>
                      </v-flex>
                      <v-flex xs12 sm6 md3>
                        <v-text-field
                          label="Comprovante de identidade"
                          v-model="idPhoto.name"
                          @click="pickIdPhoto"
                          prepend-icon="attach_file"
                          append-outer-icon="close"
                          @click:append-outer="removeFile(idPhoto)"
                          readonly
                        />
                        <input
                          type="file"
                          ref="idPhoto"
                          multiple
                          style="display: none"
                          @change="pickedPhotos($event)"
                          accept="image/*, application/pdf"
                        />
                      </v-flex>
                      <v-flex xs12 sm12>
                        <div class="font-weight-bold">Apoio</div>
                      </v-flex>
                      <v-flex xs12 sm6 md3>
                        <v-select
                          :items="[
                            'Chat',
                            'Telefone',
                            'Representante Comercial',
                          ]"
                          label="Meio da Inscrição"
                          v-model="signedcontract_by"
                          :rules="[
                            (v) =>
                              !!v ||
                              'Por favor, informe se a inscrição está ocorrendo por telefone ou chat',
                          ]"
                          required
                        ></v-select>
                      </v-flex>
                      <v-flex xs12 sm6 md3 v-if="status">
                        <v-text-field
                          v-model="status"
                          label="Status do Membro"
                          hint="readonly"
                          readonly
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm3 md3 v-if="psellers">
                        <v-autocomplete
                          :items="psellers"
                          item-text="name"
                          item-value="email"
                          label="Vendido por"
                          v-model="signedcontract_partner"
                          hint="opcional"
                        ></v-autocomplete>
                      </v-flex>
                      <v-flex xs12 sm6 md3>
                        <v-select
                          :items="['Trabalhar', 'Sem interesse']"
                          label="Ação necessária"
                          v-model="status_lead"
                          :rules="[
                            (v) =>
                              !!v ||
                              'Por favor, informe o que fazer com esse lead',
                          ]"
                          required
                        ></v-select>
                      </v-flex>
                      <v-flex xs12 sm6 md2>
                        <v-select
                          :items="payment_type_items"
                          item-value="value"
                          item-text="text"
                          label="Metodo de Pagamento*"
                          v-model="payment_type"
                          :rules="[
                            (v) =>
                              !!v || 'Por favor, informe o método de pagamento',
                          ]"
                          required
                        ></v-select>
                      </v-flex>
                      <v-flex xs12 sm2 md2>
                        <v-select
                          :items="enercred_contract_items"
                          item-value="value"
                          item-text="text"
                          label="Gerar contrato da Juntos?"
                          v-model="enercred_contract"
                          :rules="[
                            (v) =>
                              v !== '' ||
                              'Por favor, informe se deve ser gerado contrato da Enercred',
                          ]"
                          required
                        ></v-select>
                      </v-flex>
                      <v-flex xs12 sm3 md3>
                        <v-text-field
                          v-model="indicator_email"
                          label="Email de indicador (Opcional)"
                          :hint="
                            indicator_name
                              ? indicator_name
                              : 'E-mail do membro que fez a indicação'
                          "
                          prepend-icon="email"
                          name="indicator_email"
                          filled
                          rounded
                          dense
                          ref="indicator_email"
                          @change="validaEmailIndicador(indicator_email)"
                        >
                        </v-text-field>
                      </v-flex>
                      <v-flex xs6 sm6 md12>
                        <div
                          v-if="!isValidCoupon && couponMessage"
                          class="red--text font-weight-bold"
                        >
                          {{ couponMessage }}
                        </div>
                        <div
                          v-else-if="isValidCoupon && couponMessage"
                          class="green--text font-weight-bold"
                        >
                          {{ couponMessage }}
                        </div>
                      </v-flex>
                      <v-flex xs12 sm12 md12>
                        <v-autocomplete
                          :items="tabulations"
                          item-text="name"
                          label="Tabulação"
                          prepend-icon="speaker_notes"
                          v-model="tabulation"
                          :rules="[
                            (v) => !!v || 'Por favor, selecione a tabulação!',
                          ]"
                          hint="Selecione a tabulação"
                          return-object
                          required
                        ></v-autocomplete>
                      </v-flex>
                      <v-flex xs12 sm12 md12>
                        <v-textarea
                          v-model="sales_observation"
                          label="Observação"
                          placeholder="Escreva uma observação que desejar sobre a venda e contato realizado..."
                        >
                        </v-textarea>
                      </v-flex>
                    </v-layout>
                  </v-layout>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" flat @click="close">fechar</v-btn>
                <v-btn
                  color="green darken-1"
                  :disabled="
                    loading ||
                    (lead && lead.user && lead.user.status === 'ATIVO')
                  "
                  @click.prevent="save"
                  >{{
                    loading
                      ? save_btn_label
                      : is_disqualification
                        ? "Concluir"
                        : "Salvar"
                  }}
                </v-btn>
                <v-btn
                  color="blue darken-1"
                  v-if="!lead.user || (lead.user && !lead.user.status)"
                  :loading="loading"
                  :disabled="
                    loading ||
                    is_disqualification ||
                    isQualifing ||
                    isIdPhotoEmpty
                  "
                  @click.prevent="validate"
                  type="submit"
                >
                  Inscrever</v-btn
                >

                <v-btn
                  color="blue darken-1"
                  v-else-if="
                    ucs_list && ucs_list.length > 0 && status === 'ATIVO'
                  "
                  :loading="loading"
                  :disabled="
                    loading ||
                    is_disqualification ||
                    isQualifing ||
                    qualification_ids.length <= 0 ||
                    isIdPhotoEmpty
                  "
                  @click.prevent="addUC"
                  type="submit"
                  >Adicionar Novas UCs</v-btn
                >

                <v-btn
                  color="blue darken-1"
                  v-else
                  :loading="loading"
                  :disabled="
                    loading ||
                    !canSubscription ||
                    is_disqualification ||
                    isQualifing ||
                    isIdPhotoEmpty
                  "
                  @click.prevent="reSubscription"
                  type="submit"
                  >Re-Inscrever</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
        <v-snackbar
          :color="color"
          :bottom="bottom"
          :top="top"
          :left="left"
          :right="right"
          multi-line
          v-model="snackbar"
          dark
        >
          <v-icon color="white" class="mr-3"> mdi-bell-plus </v-icon>
          <div v-html="snackMessage"></div>
          <v-icon size="16" @click="snackbar = false">
            mdi-close-circle
          </v-icon>
        </v-snackbar>
      </v-form>
    </v-dialog>

    <v-dialog v-model="dialog_ucs" persistent max-width="500px">
      <v-card>
        <v-card-title> Unidades Consumidoras do Cliente na Cemig </v-card-title>
        <v-card-text>
          <v-list subheader three-line>
            <v-subheader
              >Selecione as unidades consumidoras que o membro quer
              contratar.</v-subheader
            >
            <v-list-tile
              v-for="(uc, idx) in ucs_cemig"
              v-bind:key="uc.installation_number"
            >
              <v-list-tile-action>
                <v-checkbox
                  v-model="ucs_chbox"
                  :value="uc.installation_number"
                  :color="colors_uc[idx]"
                ></v-checkbox>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>{{
                  uc.installation_number
                }}</v-list-tile-title>
                <v-list-tile-sub-title>{{ uc.address }}</v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click="dialog_ucs = false"
            >fechar</v-btn
          >
          <v-btn
            color="blue darken-1"
            :loading="loading_qualification"
            :disabled="loading_qualification"
            @click="ucs_selected()"
            >Selecionar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog_cpf" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          {{ label_loading_cpf }}
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog_venda" persistent max-width="500px">
      <v-card>
        <v-card-title> Ao aceitar o termo você concorda em: </v-card-title>
        <v-card-text>
          <v-list subheader three-line>
            <v-list-tile>
              <v-list-tile-content>
                1. Receber um percentual dos créditos gerados de acordo com seu
                consumo médio.
              </v-list-tile-content>
            </v-list-tile>
            <v-divider />
            <v-list-tile>
              <v-list-tile-content>
                2. Que é o titular da conta de luz ou possui declaração legal
                para representá-lo.
              </v-list-tile-content>
            </v-list-tile>
            <v-divider />
            <v-list-tile>
              <v-list-tile-content>
                3. Está ciente de que é necessário o aviso prévio de 90 dias
                para cancelamento da assinatura.
              </v-list-tile-content>
            </v-list-tile>
            <v-divider />
            <v-list-tile>
              <v-list-tile-content>
                4. Receberá 10% de desconto sobre os créditos recebidos em
                relação a tarifa vigente pela concessionária local.
              </v-list-tile-content>
            </v-list-tile>
            <v-divider />
            <v-list-tile>
              <v-list-tile-content>
                5. Esta ciente que somente receberá cobrança após os créditos
                chegarem em sua conta de energia.
              </v-list-tile-content>
            </v-list-tile>
            <v-divider />
            <v-list-tile>
              <v-list-tile-content>
                6. Realizará o pagamento pelos créditos recebidos dentro do
                prazo. Caso isso não ocorrá poderá ter seu nome adicionado aos
                sistemas de crédito.
              </v-list-tile-content>
            </v-list-tile>
            <v-divider />
            <v-list-tile>
              <v-list-tile-content>
                7. Permite que o representante legal da cooperativa faça a
                inscrição em seu nome junto a CEMIG.
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click="dialog_venda = false"
            >fechar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog_app" persistent max-width="500px">
      <v-card>
        <v-container fluid grid-list-lg>
          <v-card-title> Baixe nosso App </v-card-title>
          <v-card-text>
            <v-list subheader two-line>
              <v-list-tile>
                <v-list-tile-content>
                  <v-list-tile-sub-title>
                    <v-text-field
                      width="100%"
                      readonly
                      id="applestore"
                      v-model="applestore"
                      label="Apple Store"
                      value="https://apps.apple.com/br/app/enercred/id1465641135"
                    ></v-text-field>
                  </v-list-tile-sub-title>
                </v-list-tile-content>
                <v-list-tile-action>
                  <v-btn
                    icon
                    color="blue"
                    @click.prevent="copyURL('applestore')"
                  >
                    <v-icon>content_copy</v-icon>
                  </v-btn>
                </v-list-tile-action>
              </v-list-tile>
              <v-divider />
              <v-list-tile>
                <v-list-tile-content>
                  <v-list-tile-sub-title>
                    <v-text-field
                      readonly
                      id="googleplay"
                      v-model="googleplay"
                      label="Google Play"
                      value="https://play.google.com/store/apps/details?id=com.enecred.enercredapp&hl=pt_BR"
                    >
                    </v-text-field>
                  </v-list-tile-sub-title>
                </v-list-tile-content>
                <v-list-tile-action>
                  <v-btn
                    icon
                    color="blue"
                    @click.prevent="copyURL('googleplay')"
                  >
                    <v-icon>content_copy</v-icon>
                  </v-btn>
                </v-list-tile-action>
              </v-list-tile>
            </v-list>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="dialog_app = false"
              >fechar</v-btn
            >
          </v-card-actions>
        </v-container>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog_calculator" persistent max-width="450px">
      <v-card color="#FFF">
        <calculator :average="lead.average_consumption || 0" />
        <v-layout pa-2>
          <v-spacer />
          <v-btn dark color="blue" @click="dialog_calculator = false"
            >Fechar</v-btn
          >
        </v-layout>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog_phones" persistent max-width="650px">
      <v-card color="#FFF">
        <v-form ref="phones_form">
          <v-container py-0>
            <v-layout wrap>
              <v-flex xs12 md12 pa-3>
                <span class="headline">Telefones</span>
              </v-flex>
              <v-flex xs12 md12>
                <v-list two-line subheader>
                  <v-subheader>Telefone primário</v-subheader>
                  <v-list-tile>
                    <a :href="'tel:+55' + phone.replace(/\D/g, '')">
                      <v-text-field
                        type="tel"
                        v-model="phone"
                        :rules="[
                          (v) => !!v || 'Por favor, informe o celular',
                          (v) =>
                            v.length > 10 ||
                            'Ops. Parece que esse não é um número de telefone',
                        ]"
                        prepend-icon="phone"
                        return-masked-value
                        mask="(##)#####-####"
                        label="Telefone"
                        disabled
                      >
                      </v-text-field>
                    </a>
                  </v-list-tile>
                  <v-subheader>Telefones secundários</v-subheader>
                  <v-list-tile v-for="(item, index) in phones" :key="index">
                    <v-layout row>
                      <v-flex xs12 lg5>
                        <v-text-field
                          v-model="item['name']"
                          prepend-icon="badge"
                          label="Descrição"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 lg6>
                        <v-text-field
                          type="tel"
                          v-model="item['phone']"
                          prepend-icon="phone"
                          :rules="[
                            (v) =>
                              v.length > 10 ||
                              'Ops. Parece que esse não é um número de telefone',
                          ]"
                          return-masked-value
                          mask="(##)#####-####"
                          label="Telefone"
                          :append-icon="
                            item['phone'].length > 10 ? 'check' : undefined
                          "
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-list-tile>
                  <v-list-tile>
                    <v-spacer />
                    <v-btn
                      small
                      dark
                      color="tertiary"
                      @click="phones.push({ name: '', phone: '' })"
                      >Adicionar mais
                    </v-btn>
                  </v-list-tile>
                </v-list>
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
        <v-layout pa-2>
          <v-spacer />
          <v-btn dark color="blue" @click="dialog_phones = false">Fechar</v-btn>
        </v-layout>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import firestore from "@/firebase/firestore";
import statesfile from "@/model/state";
import firebase from "firebase";
import moment from "moment";
import { mapActions, mapGetters, mapState } from "vuex";
import Calculator from "../../components/sales/Calculator";
import { SET_CONVERSION } from "../../graphql/rdstation";
import { eventBus } from "../../main";
import { getBillingsByUserOpened } from "../../services/billing";
import { getConsumerUnits } from "../../services/consumer_units";
import { updateUsedCoupon } from "../../services/coupon";
import { setFbEvent } from "../../services/facebookOfflineEvents";
import { getCEP } from "../../services/getCep";
import { getCPFCemig } from "../../services/getCPFCemig";
import { getPEOPLE } from "../../services/getPeople";
import { addLead, updateLead } from "../../services/leads";
import {
  finishQualification,
  initQualification,
} from "../../services/qualification";
import { setWinOpportunity } from "../../services/rdstation";
import { uploadData } from "../../services/sales";
import { saveAnalytics } from "../../services/save_analytics";
import { uploadDoc } from "../../services/uploadDocs";
import {
  getMember,
  getPartnerSellers,
  getUserByEmail,
  storeCustomer,
  updateUser,
} from "../../services/users";
import lista_profissoes from "../../utils/profissoes.json";
import { formatPhone, reversePhone } from "../../utils/utils";
import PlanConditions from "../plans/PlanConditions.vue";
import DisqualifiedCard from "./qualification/DisqualifiedCard.vue";
import NotQualifiedCard from "./qualification/NotQualifiedCard.vue";
import QualifiedCard from "./qualification/QualifiedCard.vue";
import QualifyingCard from "./qualification/QualifyingCard.vue";

export default {
  data: function () {
    return {
      is_indicator_email_valid: false,
      indicator_name: null,
      dialog_member: false,
      cpf_duplicated: false,
      cpf_duplicated_msg: "",
      dialog_ucs: false,
      dialog_cpf: false,
      dialog_venda: false,
      dialog_app: false,
      dialog_calculator: false,
      dialog_phones: false,
      financial_pending: null,
      label_loading_cpf: "Validando CPF informado",
      ucs_chbox: [],
      valid: false,
      profissoes: lista_profissoes,
      lead: {},
      cadLead: "new",
      name: "",
      nome_titular: "",
      phone: "",
      phones: [{ name: "", phone: "" }],
      email: "",
      average: 0,
      person_type_items: [
        { text: "Pessoa Física", value: "pf" },
        { text: "Pessoa Jurídica", value: "pj" },
      ],
      enercred_contract_items: [
        { text: "Sim", value: true },
        { text: "Não", value: false },
      ],
      contract_time_items: [
        { text: "1 Ano", value: 12 },
        { text: "3 Anos", value: 36 },
        { text: "5 Anos", value: 60 },
      ],
      enercred_contract: true,
      person_type: "pf",
      company_name: "",
      cpf: "",
      old_cpf: "",
      cpf_legal_responsible: "",
      rg: "",
      birthday: "",
      mother_name: "",
      orgao_expeditor: "",
      user: {},
      marital_status: [
        { text: "Solteiro(a)", value: "Solteiro(a)" },
        { text: "Casado(a)", value: "Casado(a)" },
        { text: "Separado(a)", value: "Separado(a)" },
        { text: "Divorciado(a)", value: "Divorciado(a)" },
        { text: "Viúvo(a)", value: "Viúvo(a)" },
      ],
      marital_status_value: "",
      marital_type: [
        { text: "Comunhão Universal de Bens", value: "Universal de bens" },
        { text: "Comunhão Parcial de Bens", value: "Parcial de bens" },
        { text: "Separação Total de Bens", value: "Separação total" },
        {
          text: "Participação Final nos Aquestos",
          value: "Final nos aquestos",
        },
      ],
      marital_type_value: "",
      gender: "",
      cemig_status: true,
      cep: "",
      logradouro: "",
      numero: "",
      complemento: "",
      bairro: "",
      localidade: "",
      uf: "",
      state: {
        initials: "MG",
        name: "Minas Gerais",
      },
      profissao: "",
      consumer_unit: "",
      states: statesfile.estados,
      payment_type_items: [
        { text: "Boleto", value: "boleto" },
        { text: "Pix", value: "pix" },
      ],
      payment_type: "",
      sales_observation: null,
      status: "",
      signedcontract_at: "",
      signedcontract_partner: "",
      signedcontract_by: "",
      loading: false,
      loading_cpf: false,
      loading_cep: false,
      loading_qualification: false,
      color: null,
      utm_source: "",
      utm_medium: "",
      utm_campaign: "",
      utm_term: "",
      utm_content: "",
      platform: "super",
      colors: ["purple", "info", "success", "warning", "error"],
      top: true,
      bottom: false,
      left: false,
      right: false,
      snackMessage: "",
      snackbar: false,
      agent_email: null,
      activator: null,
      attach: null,
      colors_uc: ["green", "purple", "indigo", "cyan", "teal", "orange"],
      editing: null,
      index: -1,
      items: [
        { header: "Selecione um opção ou adicione um núm. de instalação" },
      ],
      nonce: 1,
      menu: false,
      ucs: [],
      status_lead: "Trabalhar",
      applestore: "https://apps.apple.com/br/app/enercred/id1465641135",
      googleplay:
        "https://play.google.com/store/apps/details?id=com.enecred.enercredapp&hl=pt_BR",
      processo_vendas: {
        cordialidade: true,
        produto: false,
        titularidade: false,
        venda: false,
        condicoes: false,
        duasfaturas: false,
      },
      contract_time: 12,
      contract_time_enable: false,
      ucs_list: null,
      ucs_cemig: [],
      uc: {},
      qualification_ids: [],
      is_disqualification: false,
      x: 0,
      search: null,
      y: 0,
      cupom: null,
      isValidCoupon: true,
      couponMessage: null,
      loadingCupom: false,
      disabledCupom: false,
      psellers: null,
      plans_economy: [],
      selected_plan: null,
      docfrente: null,
      docverso: null,
      docself: null,
      dialog_fotos: false,
      e6: 1,
      fileInfo: null,
      save_btn_label: "Salvar",
      tabulation: null,
      utility_company: "cemig",
      indicator_email: "",
      idPhoto: {
        name: "",
        data: null,
      },
      availableFormats: ["jpg", "jpeg", "png", "pdf"],
      uc_plans: [
        { text: "20%", value: "teste1" },
        { text: "25%", value: "teste2" },
      ],
      uc_person_type: "pf",
      rate_classes: ["Monofásico", "Bifásico", "Trifásico"],
      sub_classes: [
        "Comercial",
        "Outros Serviços e Outras Ativ",
        "Residencial",
      ],
      fare_amount: 0.96,
      consumerunit: {
        id: "",
        installation_number: "",
        customer_number: "",
        power_plant_id: "",
        percentage: 0,
        percentage_discount: 10,
        fare_amount: 0.96,
        user_id: "",
        label: "",
        rate_class: "Bifásico",
        sub_class: "Residencial",
        average: 0,
        creditos: 0,
        mensalidade: 0,
        economia_mensal: 0,
        economia_anual: 0,
        economia_contrato: 0,
        status: "awaiting_contract_generation",
        address: {
          address: "",
          address_number: "",
          address_complement: "",
          district: "",
          postal_code: "",
          state: {
            name: "Minas Gerais",
            initials: "MG",
          },
          city: "",
          country: {
            name: "Brasil",
            initials: "BR",
          },
        },

        user: {
          customer_id: "",
          buyer_id: "",
          name: "",
          email: "",
          phone: "",
          cpf: "",
          group: "",
          payment_type: "",
          card_default: "",
        },
        powerplant: {
          power_plant_id: "",
          name: "",
          power_monthly: "",
        },
        history: [
          { mes_ano: "", consumo: 0, dias: 30 },
          { mes_ano: "", consumo: 0, dias: 30 },
          { mes_ano: "", consumo: 0, dias: 30 },
          { mes_ano: "", consumo: 0, dias: 30 },
        ],
        initial_average_comsumption: "",
        contract_id: null,
        cpf: null,
        person_type: null,
        utility_company: null,
      },
    };
  },

  components: {
    Calculator,
    QualifiedCard,
    DisqualifiedCard,
    QualifyingCard,
    NotQualifiedCard,
    PlanConditions,
  },
  created() {
    const vm = this;
    eventBus.$on("dialog_member", function (value) {
      this.loading = false;
      vm.dialog_member = value;
    });
    this.agent_email = this.loggedUser?.email || null;
    const months = [
      "JAN",
      "FEV",
      "MAR",
      "ABR",
      "MAI",
      "JUN",
      "JUL",
      "AGO",
      "SET",
      "OUT",
      "NOV",
      "DEZ",
    ];
    let d = new Date();
    if (
      this.consumerunit.history[0].mes_ano === "" &&
      this.consumerunit.history[0].consumo === 0
    ) {
      for (let i = 0; i < 12; i++) {
        let m = d.getMonth();

        d.setMonth(m - 1);

        if (
          d.getMonth() != m - 1 &&
          (d.getMonth() != 11 || (m == 11 && d.getDate() == 1))
        )
          d.setDate(0);

        let mes_ano =
          months[d.getMonth()] +
          "/" +
          d.getFullYear().toString().substring(2, 4);
        this.consumerunit.history[i].mes_ano = mes_ano;
      }
    }
  },

  computed: {
    ...mapState("sales", ["coupon", "tabulations"]),
    ...mapState("configuration", ["utilityCompanies"]),
    ...mapGetters("sales", ["plansByUtilityCompany"]),
    ...mapGetters("qualification", ["qualifications", "isQualifing"]),
    ...mapGetters(["loggedUser"]),

    assinou() {
      if (this.user && this.user.signedcontract_at) {
        let msg = "";
        if (!this.user.contract_id && this.user.status !== "ATIVO") {
          msg =
            "Atenção: Cliente fez cadastro no passado e cancelou ou não foi ativado, revender para esse cliente?";
        } else {
          msg =
            'Atenção: Cliente <span class="font-weight-bold">' +
            this.user.status;
        }
        return msg;
      } else {
        return "";
      }
    },

    possuiContrato() {
      return !!(this.user && this.user.signedcontract_at);
    },

    plansEconomySort() {
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return this.plans_economy.sort((a, b) => (a.order > b.order ? 1 : -1));
    },

    plans() {
      return this.plansByUtilityCompany(this.utility_company);
    },

    isIdPhotoEmpty() {
      if (this.person_type === "pj")
        return this.idPhoto.name.trim() === "" && this.idPhoto.data === null;

      return false;
    },
  },

  async mounted() {
    this.loading = true;
    if (this.utilityCompanies?.length <= 0) this.getUtilityCompanies();

    if (
      !this.tabulations ||
      (this.tabulations && this.tabulations.length <= 0)
    ) {
      await this.getTabulations();
    }

    eventBus.$on("Lead", (lead) => {
      let _lead = lead;
      this.lead = {};
      this.user = {};
      this.loading = true;
      if (lead) {
        if (lead.id && lead.saved_partner !== this.loggedUser.email) {
          let newLead = {
            updated_at: new Date(),
            tabulation: "working",
            saved_at: new Date(),
            saved_by: "SUPER",
            saved_source: this.loggedUser.partner_id || "enercred",
            saved_partner: this.loggedUser.email,
          };
          updateLead(lead.email, newLead)
            .then(() => {})
            .catch((err) => {
              this.snack(
                "Houve um erro inesperado. Procure nosso suporte!",
                "red",
                "top",
              );
              console.error("Erro ao pegar lead: ", err);
              this.loading = false;
            });
          _lead = {
            ...lead,
            ...newLead,
          };
        }
        this.setLead(_lead);
      } else {
        this.clearUser();
      }
      this.getPSeller();
      this.getPlansByParams({ person_type: this.person_type });
      this.dialog_member = true;
      this.loading = false;
    });

    this.signedcontract_partner = this.loggedUser.email;

    if (
      this.loggedUser.group.indexOf("sales_partner") > -1 ||
      this.loggedUser.group.indexOf("sales_partner_management") > -1
    ) {
      this.tabulation = this.tabulations.filter(
        (t) => t.name === "ENVIO DE CONTRATO/ CONEXÃO",
      )[0];
      this.signedcontract_by = "Representante Comercial";
    }
  },

  watch: {
    ucs(val, prev) {
      if (val.length === prev.length) return;
      this.ucs = val.map((v) => {
        if (typeof v === "string") {
          v = {
            text: v,
            color: this.colors[this.nonce - 1],
          };
          this.items.push(v);
          this.nonce++;
        }
        return v;
      });
    },

    qualifications() {
      let disqualification = this.qualifications.reduce((sum, cur) => {
        if (cur.status === "disqualified") return sum + 1;
        else return sum;
      }, 0);
      if (
        disqualification === this.qualifications.length &&
        disqualification > 0
      ) {
        this.is_disqualification = true;
      } else {
        this.is_disqualification = false;
      }
    },

    average() {
      this.getPlansEconomy(this.average, this.plans);
    },

    plans() {
      this.getPlansEconomy(this.average, this.plans);
    },

    async person_type() {
      if (this.coupon?.plan_id)
        this.getPlansByParams({
          person_type: this.person_type,
          plan_id: this.coupon.plan_id,
        });
      else await this.getPlansByParams({ person_type: this.person_type });
    },
  },

  deactivated() {
    this.resetState();
  },

  destroyed() {
    this.resetState();
    this.clearUser();
  },

  methods: {
    ...mapActions("qualification", ["resetState", "getQualifications"]),
    ...mapActions("sales", [
      "getCoupons",
      "getPlansByParams",
      "getTabulations",
    ]),
    ...mapActions("configuration", ["getUtilityCompanies"]),

    async callQualification() {
      const ucs = this.ucs.map((uc) => {
        uc = uc.text || uc;
        return uc;
      });

      if (ucs.length <= 0) {
        this.resetState();
        return;
      }

      this.loading = true;
      if (this.utility_company === "neoenergia-pe") {
        await initQualification(
          this.cpf,
          null,
          null,
          "inside_sales",
          false,
          ucs,
          this.utility_company,
          null,
          this.agent_email,
        )
          .then(async (ret) => {
            if (ret.status === 200) {
              this.qualification_ids = ret.data.ids;
              const params = {
                cpf: this.cpf,
                qualification_ids: this.qualification_ids,
              };
              await this.getQualifications(params);
            } else {
              this.snack("Erro ao iniciar qualificação.", "warning", "bottom");
            }
          })
          .catch((err) => {
            console.error(err);
            this.snack("Erro ao iniciar qualificação.", "warning", "bottom");
          });
      } else {
        await initQualification(
          this.cpf,
          null,
          ucs,
          "inside_sales",
          false,
          null,
          this.utility_company,
          null,
          this.agent_email,
        )
          .then((ret) => {
            if (ret.status === 200) {
              this.qualification_ids = ret.data.ids;
              const params = {
                cpf: this.cpf,
                qualification_ids: this.qualification_ids,
              };
              this.getQualifications(params);
            } else {
              this.snack("Erro ao iniciar qualificação.", "warning", "bottom");
            }
          })
          .catch((err) => {
            console.error(err);
            this.snack(
              `Erro ao iniciar qualificação. ${
                err && err.response ? err.response.data : ""
              }`,
              "warning",
              "bottom",
            );
          });
      }
      this.loading = false;
    },

    undo() {
      this.$refs.signaturePad.clearSignature();
    },

    onFileInfo(value) {
      this.fileInfo = value;
      this.ui.snackbar.fileInfo = true;
    },

    saveSignature() {
      const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
      console.error(isEmpty);
      console.error(data);
    },

    close() {
      this.dialog_member = false;
      this.resetState();
    },

    choosePlan(plan) {
      this.selected_plan = plan;
    },

    call(phone) {
      const newPhone = formatPhone(phone, "+55").split("+55")[1];
      window.open("tel:" + newPhone, "_self");
    },

    backQueue() {
      let newLead = {
        updated_at: new Date(),
        tabulation: "towork",
        saved_source: firebase.firestore.FieldValue.delete(),
        saved_partner: firebase.firestore.FieldValue.delete(),
      };
      updateLead(this.email, newLead)
        .then(() => {
          this.snack("Lead devolvido para  com sucesso!", "green", "top");
          this.loading = false;
          this.dialog_member = false;
        })
        .catch((err) => {
          this.snack(
            "Houve um erro inesperado. Procure nosso suporte!",
            "red",
            "top",
          );
          console.error("Erro ao criar lead: ", err);
          this.loading = false;
        });
    },

    setLead(lead) {
      this.lead = lead;
      this.cadLead = "edit";
      this.platform = lead.platform || "super";

      if (lead.plan && lead.plan.id) {
        this.selected_plan = this.plans.filter((value) => {
          return value.id === lead.plan.id;
        })[0];
      }

      if (lead.user) {
        if (this.cpf !== "" && lead.user.cpf !== this.cpf) {
          this.snack(
            "E-mail digitaddo possui cadastro com o CPF Direrente",
            "red",
            "top",
          );
          return;
        }
        this.person_type = lead.user.person_type || "pf";
        if (
          (!this.plans || this.plans.length <= 0) &&
          this.person_type &&
          this.person_type != ""
        ) {
          this.getPlansByParams({ person_type: this.person_type });
        }
        let phone = reversePhone(lead.user.phone);
        let phones;
        if (lead && lead.user && lead.user.other_phones) {
          phones = lead.user.other_phones.map((e) => {
            return {
              name: e.name,
              phone: reversePhone(e.phone, "55"),
            };
          });
        }
        this.user = lead.user;
        this.name = lead.user.name;

        this.company_name = lead.user.company_name || "";
        this.email = lead.user.email;
        this.phone = phone;
        this.phones = phones;
        this.average = lead.user.average_consumption;
        this.cep = lead.user.postal_code;
        this.cpf = lead.user.cpf;
        this.cpf_legal_responsible = lead.user.cpf_legal_responsible;
        this.old_cpf = this.cpf;
        if (lead.user.ID_document) {
          let rg = lead.user.ID_document.split("-")[0];
          let org = lead.user.ID_document.split("-")[1];
          this.rg = rg;
          this.orgao_expeditor = org;
        }
        this.birthday = this.reverseDate(lead.user.date_of_birth);
        this.gender = lead.user.gender;
        this.consumer_unit = lead.user.installation_number || "";
        this.mother_name = lead.user.mother_name || "";
        if (lead.user.address) {
          this.cep =
            lead.user.address.postal_code ||
            lead.address.postal_code ||
            lead.postal_code ||
            null;
          this.logradouro = lead.user.address.address;
          this.numero = lead.user.address.address_number;
          this.complemento = lead.user.address.address_complement;
          this.bairro = lead.user.address.district;
          this.localidade = lead.user.address.city;
          this.state = lead.user.address.state;
        }
        if (!this.installation_numbers)
          this.installation_numbers = lead.user.installation_numbers || [];
        this.ucs = this.installation_numbers;
        this.items = lead.user.installation_numbers || [];
        this.payment_type = lead.user.payment_type;
        this.unique_billing = lead.user.unique_billing;
        this.sales_observation =
          lead.user.sales_observation || lead.sales_observation || null;
        this.status = lead.user.status;
        this.signedcontract_at = this.formatDate(lead.user.signedcontract_at);
        this.signedcontract_by =
          lead.user.signedcontract_by === "onboarding" ||
          lead.user.signedcontract_by === "mobile_app"
            ? ""
            : lead.user.signedcontract_by;
        this.enercred_contract = lead.user.enercred_contract;
        if (lead.user.coupon) this.coupon = lead.user.coupon;
      } else {
        this.user = {};
        this.clearUser();
        if (lead.name) {
          this.person_type = lead.person_type || "pf";
          if (
            (!this.plans || this.plans.length <= 0) &&
            this.person_type &&
            this.person_type != ""
          ) {
            this.getPlansByParams({ person_type: this.person_type });
          }
          let phone = reversePhone(lead.phone);
          let phones = [];
          if (lead && lead.other_phones) {
            phones = lead.other_phones.map((e) => {
              return {
                name: e.name,
                phone: reversePhone(e.phone, "55"),
              };
            });
          }
          this.name = lead.name;
          this.person_type = lead.person_type || "pf";
          this.company_name = lead.company_name || "";
          this.email = lead.email;
          this.phone = phone;
          this.phones = phones;
          this.average = lead.average_consumption;
          this.cep = lead.postal_code;
          this.cpf = lead.cpf || "";
          this.cpf_legal_responsible = lead.cpf_legal_responsible;
          this.old_cpf = this.cpf || "";
          if (lead.ID_document) {
            let rg = lead.ID_document.split("-")[0];
            let org = lead.ID_document.split("-")[1];
            this.rg = rg;
            this.orgao_expeditor = org;
          }
          this.birthday = this.reverseDate(lead.date_of_birth) || "";
          this.gender = lead.gender || "";
          this.consumer_unit = lead.installation_number || "";
          this.mother_name = lead.mother_name || "";
          if (lead.address) {
            this.cep = lead.address.postal_code || lead.postal_code || null;
            this.logradouro = lead.address.address;
            this.numero = lead.address.address_number;
            this.complemento = lead.address.address_complement;
            this.bairro = lead.address.district;
            this.localidade = lead.address.city;
            this.state = lead.address.state;
          }
          if (!this.installation_numbers)
            this.installation_numbers = lead.installation_numbers || [];
          this.ucs = lead.installation_numbers || [];
          this.items = lead.installation_numbers || [];
          this.payment_type = lead.payment_type || "";
          this.unique_billing = lead.unique_billing;
          this.sales_observation = lead.sales_observation || null;
          this.signedcontract_by =
            lead.signedcontract_by === "onboarding" ||
            lead.signedcontract_by === "mobile_app"
              ? ""
              : lead.signedcontract_by;
          this.enercred_contract = lead.enercred_contract || true;
          if (lead.coupon) this.coupon = lead.coupon;
          if (lead.promo_code) this.indicator_email = lead.promo_code;
        }
      }
    },

    copyURL(element) {
      let Url = document.getElementById(element);
      Url.innerHTML = Url.value;
      Url.select();
      document.execCommand("copy");
      alert("Copiado com sucesso.");
    },

    edit(index, item) {
      if (!this.editing) {
        this.editing = item;
        this.index = index;
      } else {
        this.editing = null;
        this.index = -1;
      }
    },

    filter(item, queryText, itemText) {
      if (item.header) return false;

      const hasValue = (val) => (val != null ? val : "");

      const text = hasValue(itemText);
      const query = hasValue(queryText);

      return (
        text.toString().toLowerCase().indexOf(query.toString().toLowerCase()) >
        -1
      );
    },

    buscaCep(cep) {
      if (cep && cep !== "") {
        this.loading_cep = true;
        getCEP(cep)
          .then((result) => {
            this.logradouro = result.data.logradouro;
            this.complemento = result.data.complemento;
            this.bairro = result.data.bairro;
            this.localidade = result.data.localidade;
            this.uf = result.data.UF;
            this.loading_cep = false;
          })
          .catch((error) => {
            this.snack(
              "Erro ao buscar o CEP informado. Erro: " + error,
              "red",
              top,
            );
            this.loading_cep = false;
          });
      }
    },

    show_dialog_ucs() {
      if (this.utility_company === "cemig") this.dialog_ucs = true;
      else
        this.snack(
          "Essa funcionalidade só existe para clientes CEMIG no momento",
          "error",
          "bottom",
        );
    },

    async buscaMember(param, type) {
      this.dialog_cpf = true;
      this.label_loading_cpf =
        "Verificando se " + type + " já está cadastrado...";
      await getMember(param, type)
        .then(async (lead) => {
          if (lead && lead.id && lead.user && lead.user.id) {
            let _hasSubscription = await this.hasSubscription(
              lead.user ? lead.user : lead.id,
            );
            if (_hasSubscription && _hasSubscription.error) {
              console.error(_hasSubscription.msg);
              this.snack(_hasSubscription.msg, "red", "top");
              this.financial_pending = _hasSubscription.msg;
              this.dialog_cpf = false;
              return;
            } else if (_hasSubscription && _hasSubscription.items) {
              this.ucs_list = _hasSubscription.items;
            }
            this.setLead(lead);
            this.dialog_cpf = false;
          } else if (lead && lead.id) {
            this.setLead(lead);
            this.dialog_cpf = false;
          } else {
            this.dialog_cpf = false;
          }
        })
        .catch((error) => {
          console.error("error: ", error);
          this.dialog_cpf = false;
        });
    },

    async buscaDadosComplementares(cpf, validaDuplicate) {
      this.dialog_cpf = true;
      this.label_loading_cpf = "Verificando se CPF já está cadastrado...";
      const cpfExists = await this.validaCPFNaBase(cpf);
      if (validaDuplicate && cpfExists) {
        console.log("cpfExists: ", cpfExists);
        if (this.cadLead !== "edit") {
          this.valid = false;
        }
        this.dialog_cpf = false;
      } else {
        if (
          this.utility_company === "cemig" &&
          cpf &&
          cpf !== "" &&
          this.person_type === "pf"
            ? this.validaCPF(cpf)
            : this.validaCNPJ(cpf)
        ) {
          this.label_loading_cpf = "Buscando dados do membro na CEMIG...";
          // console.log("busca CPF na Cemig")
          await getCPFCemig(cpf)
            .then((ret) => {
              if (ret.status === 200) {
                this.ucs_cemig = ret.data;
                ret.data.forEach((data, idx) => {
                  const item_uc = {
                    text: data.installation_number,
                    color: this.colors[idx],
                  };
                  this.items.push(item_uc);
                });
                this.dialog_ucs = true;
              } else {
                this.snack(
                  "Atenção: CPF não encontrado no site da CEMIG, validar se o CPF informado é do titular da conta.",
                  "warning",
                  "bottom",
                );
                this.dialog_cpf = false;
                this.valid = false;
              }
            })
            .catch((err) => {
              console.error(err);
              this.snack(
                `Erro ao buscar dados na CEMIG. ${
                  err && err.response ? err.response.data : ""
                }`,
                "warning",
                "bottom",
              );
            });
          this.label_loading_cpf = "Buscando dados complementares do membro...";
          if (this.person_type === "pf")
            getPEOPLE(cpf)
              .then((result) => {
                if (result.data.BasicData) {
                  this.nome_titular = result.data.BasicData.Name || "";
                  this.gender = result.data.BasicData.Gender || "";
                  this.nacionalidade =
                    result.data.BasicData.BirthCountry || "brasileiro(a)";
                  this.mother_name = result.data.BasicData.MotherName || "";
                  this.birthday = this.formatDate(
                    result.data.BasicData.BirthDate,
                  );
                }
                if (
                  result.data.ProfessionData &&
                  result.data.ProfessionData.TotalProfessions > 0
                ) {
                  if (
                    result.data.ProfessionData.Professions &&
                    result.data.ProfessionData.Professions.length > 0
                  ) {
                    result.data.ProfessionData.Professions.forEach((t) => {
                      if (t.Level !== "UNKNOWN") {
                        this.profissao = t.Level;
                      }
                    });
                  }
                }
                this.dialog_cpf = false;
              })
              .catch((error) => {
                console.error(
                  "CPF não encontrado na base de dados externa. Por favor, preencha os dados (Data nascimento, sexo, etc...) manualmente. Erro: " +
                    error,
                );
                this.dialog_cpf = false;
              });
          else this.dialog_cpf = false;
        } else {
          this.snack(
            "Essa funcionalidade só existe para clientes CEMIG no momento",
            "error",
            "bottom",
          );
          this.dialog_cpf = false;
        }
      }
    },

    async ucs_selected() {
      this.loading_qualification = true;
      let ucs = await this.ucs_chbox.map((el) => el);
      await initQualification(
        this.cpf,
        null,
        ucs,
        "inside_sales",
        false,
        null,
        this.utility_company,
        null,
        this.agent_email,
      )
        .then((ret) => {
          if (ret.status === 200) {
            this.qualification_ids = ret.data.ids;
            const params = {
              cpf: this.cpf,
              qualification_ids: this.qualification_ids,
            };
            this.getQualifications(params);
          } else {
            this.snack("Erro ao iniciar qualificação.", "warning", "bottom");
          }
        })
        .catch((err) => {
          console.error(err);
          this.snack(
            `Erro ao iniciar qualificação. ${
              err && err.response ? err.response.data : ""
            }`,
            "warning",
            "bottom",
          );
        });
      this.loading_qualification = false;
      this.ucs_chbox.map((sel, index) => {
        const obj = {
          text: sel,
          color: this.colors[index],
        };
        this.ucs.push(obj);
      });
      this.dialog_ucs = false;

      if (this.$refs["rg"]) this.$refs["rg"].focus();
    },

    clearUser() {
      ((this.is_indicator_email_valid = false),
        (this.indicator_name = null),
        (this.cpf_duplicated = false),
        (this.cpf_duplicated_msg = ""),
        (this.dialog_ucs = false),
        (this.dialog_cpf = false),
        (this.dialog_venda = false),
        (this.dialog_app = false),
        (this.dialog_calculator = false),
        (this.dialog_phones = false),
        (this.financial_pending = null),
        (this.label_loading_cpf = "Validando CPF informado"),
        (this.ucs_chbox = []),
        (this.valid = false),
        (this.profissoes = lista_profissoes),
        (this.lead = {}),
        (this.cadLead = "new"),
        (this.name = ""),
        (this.nome_titular = ""),
        (this.phone = ""),
        (this.phones = [{ name: "", phone: "" }]),
        (this.email = ""),
        (this.average = 0),
        (this.person_type_items = [
          { text: "Pessoa Física", value: "pf" },
          { text: "Pessoa Jurídica", value: "pj" },
        ]),
        (this.enercred_contract_items = [
          { text: "Sim", value: true },
          { text: "Não", value: false },
        ]),
        (this.contract_time_items = [
          { text: "1 Ano", value: 12 },
          { text: "3 Anos", value: 36 },
          { text: "5 Anos", value: 60 },
        ]),
        (this.enercred_contract = true),
        (this.person_type = "pf"),
        (this.company_name = ""),
        (this.cpf = ""),
        (this.old_cpf = ""),
        (this.cpf_legal_responsible = ""),
        (this.rg = ""),
        (this.birthday = ""),
        (this.mother_name = ""),
        (this.orgao_expeditor = ""),
        (this.user = {}),
        (this.marital_status = [
          { text: "Solteiro(a)", value: "Solteiro(a)" },
          { text: "Casado(a)", value: "Casado(a)" },
          { text: "Separado(a)", value: "Separado(a)" },
          { text: "Divorciado(a)", value: "Divorciado(a)" },
          { text: "Viúvo(a)", value: "Viúvo(a)" },
        ]),
        (this.marital_status_value = ""),
        (this.marital_type = [
          { text: "Comunhão Universal de Bens", value: "Universal de bens" },
          { text: "Comunhão Parcial de Bens", value: "Parcial de bens" },
          { text: "Separação Total de Bens", value: "Separação total" },
          {
            text: "Participação Final nos Aquestos",
            value: "Final nos aquestos",
          },
        ]),
        (this.marital_type_value = ""),
        (this.gender = ""),
        (this.cemig_status = true),
        (this.cep = ""),
        (this.logradouro = ""),
        (this.numero = ""),
        (this.complemento = ""),
        (this.bairro = ""),
        (this.localidade = ""),
        (this.uf = ""),
        (this.state = {
          initials: "MG",
          name: "Minas Gerais",
        }),
        (this.profissao = ""),
        (this.consumer_unit = ""),
        (this.states = statesfile.estados),
        (this.payment_type_items = [
          { text: "Boleto", value: "boleto" },
          { text: "Pix", value: "pix" },
        ]),
        (this.payment_type = ""),
        (this.sales_observation = null),
        (this.status = ""),
        (this.signedcontract_at = ""),
        (this.signedcontract_partner = ""),
        (this.signedcontract_by = ""),
        (this.loading = false),
        (this.loading_cpf = false),
        (this.loading_cep = false),
        (this.loading_qualification = false),
        (this.color = null),
        (this.utm_source = ""),
        (this.utm_medium = ""),
        (this.utm_campaign = ""),
        (this.utm_term = ""),
        (this.utm_content = ""),
        (this.platform = "super"),
        (this.colors = ["purple", "info", "success", "warning", "error"]),
        (this.top = true),
        (this.bottom = false),
        (this.left = false),
        (this.right = false),
        (this.snackMessage = ""),
        (this.snackbar = false),
        (this.activator = null),
        (this.attach = null),
        (this.colors_uc = [
          "green",
          "purple",
          "indigo",
          "cyan",
          "teal",
          "orange",
        ]),
        (this.editing = null),
        (this.index = -1),
        (this.items = [
          { header: "Selecione um opção ou adicione um núm. de instalação" },
        ]),
        (this.nonce = 1),
        (this.menu = false),
        (this.ucs = []),
        (this.status_lead = "Trabalhar"),
        (this.applestore =
          "https://apps.apple.com/br/app/enercred/id1465641135"),
        (this.googleplay =
          "https://play.google.com/store/apps/details?id=com.enecred.enercredapp&hl=pt_BR"),
        (this.processo_vendas = {
          cordialidade: true,
          produto: false,
          titularidade: false,
          venda: false,
          condicoes: false,
          duasfaturas: false,
        }),
        (this.contract_time = 12),
        (this.contract_time_enable = false),
        (this.ucs_list = null),
        (this.ucs_cemig = []),
        (this.uc = {}),
        (this.qualification_ids = []),
        (this.is_disqualification = false),
        (this.x = 0),
        (this.search = null),
        (this.y = 0),
        (this.cupom = null),
        (this.isValidCoupon = true),
        (this.couponMessage = null),
        (this.loadingCupom = false),
        (this.psellers = null),
        (this.plans_economy = []),
        (this.selected_plan = null),
        (this.docfrente = null),
        (this.docverso = null),
        (this.docself = null),
        (this.dialog_fotos = false),
        (this.e6 = 1),
        (this.fileInfo = null),
        (this.save_btn_label = "Salvar"),
        (this.tabulation = null),
        (this.utility_company = "cemig"),
        (this.utility_companies = [
          { text: "CEMIG", value: "cemig" },
          { text: "Neo Energia Pernambuco", value: "neoenergia-pe" },
          { text: "CPFL Piratininga", value: "cpfl-piratininga" },
        ]),
        (this.indicator_email = ""),
        (this.idPhoto = {
          name: "",
          data: null,
        }),
        (this.availableFormats = ["jpg", "jpeg", "png", "pdf"]));
    },

    getPlansEconomy(average, plans) {
      this.plans_economy = [];
      for (const plan of plans) {
        let mounth =
          (average * (1 - 0.09) - 50) * (plan.discount / 100 || 0.15);
        let year = mounth * 12;
        this.plans_economy.push({
          economy_mounth: mounth,
          economy_year: year,
          ...plan,
        });
      }
    },

    snack(message, color, ...args) {
      this.top = false;
      this.bottom = false;
      this.left = false;
      this.right = false;

      for (const loc of args) {
        this[loc] = true;
      }

      this.color = color;
      this.snackMessage = message;
      this.snackbar = true;
    },

    formatDate(value) {
      if (!value || value === "") return "";
      if (new Date(value)) {
        return moment.utc(new Date(value)).format("DD/MM/YYYY");
      } else {
        return value;
      }
    },

    validaCPF(strCPF) {
      if (!strCPF) return "";
      let Soma;
      let Resto;
      Soma = 0;
      if (strCPF == "00000000000") return false;
      if (strCPF == "11111111111") return false;

      for (let i = 1; i <= 9; i++)
        Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (11 - i);
      Resto = (Soma * 10) % 11;

      if (Resto == 10 || Resto == 11) Resto = 0;
      if (Resto != parseInt(strCPF.substring(9, 10))) return false;

      Soma = 0;
      for (let i = 1; i <= 10; i++)
        Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (12 - i);
      Resto = (Soma * 10) % 11;

      if (Resto == 10 || Resto == 11) Resto = 0;
      return Resto == parseInt(strCPF.substring(10, 11));
    },

    validaCNPJ(strCNPJ) {
      if (!strCNPJ) return "";
      let cnpj = strCNPJ.replace(/[^\d]+/g, "");

      if (cnpj.length != 14) return false;

      if (
        cnpj == "00000000000000" ||
        cnpj == "11111111111111" ||
        cnpj == "22222222222222" ||
        cnpj == "33333333333333" ||
        cnpj == "44444444444444" ||
        cnpj == "55555555555555" ||
        cnpj == "66666666666666" ||
        cnpj == "77777777777777" ||
        cnpj == "88888888888888" ||
        cnpj == "99999999999999"
      )
        return false;

      let tamanho = cnpj.length - 2;
      let numeros = cnpj.substring(0, tamanho);
      let digitos = cnpj.substring(tamanho);
      let soma = 0;
      let pos = tamanho - 7;
      for (let i = tamanho; i >= 1; i--) {
        soma += numeros.charAt(tamanho - i) * pos--;
        if (pos < 2) pos = 9;
      }
      let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
      if (resultado != digitos.charAt(0)) return false;

      tamanho = tamanho + 1;
      numeros = cnpj.substring(0, tamanho);
      soma = 0;
      pos = tamanho - 7;
      for (let i = tamanho; i >= 1; i--) {
        soma += numeros.charAt(tamanho - i) * pos--;
        if (pos < 2) pos = 9;
      }
      resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
      return resultado == digitos.charAt(1);
    },

    async validaEmailIndicador(email) {
      getUserByEmail(email)
        .then((res) => {
          if (res.size > 0 && res.docs[0].data().name) {
            this.indicator_name = res.docs[0].data().name;
            return true;
          } else {
            this.indicator_name = null;
            return false;
          }
        })
        .catch((e) => {
          console.error(e);
          this.indicator_name = null;
        });
    },

    async validaCPFNaBase(cpf) {
      if (
        this.person_type === "pf" ? this.validaCPF(cpf) : this.validaCNPJ(cpf)
      ) {
        const ret = await firestore
          .collection("users")
          .where("cpf", "==", cpf)
          .limit(1)
          .get();
        if (ret.size > 0) {
          let msg =
            `${
              this.person_type === "pf" ? "CPF" : "CNPJ"
            } já cadastrado na base com o email ` +
            ret.docs[0].data().email +
            ".";
          if (ret.docs[0].data().signedcontract_at) {
            let dt_assin = moment(
              new Date(ret.docs[0].data().signedcontract_at),
            ).format("DD/MM/YYYY HH:mm");
            msg =
              msg +
              "<br>Cliente assinou o contrato em <b>" +
              dt_assin +
              "</b> por meio ";
            if (
              ret.docs[0].data().signedcontract_by === "SUPER" ||
              ret.docs[0].data().signedcontract_by === "phone" ||
              ret.docs[0].data().signedcontract_by === "chat" ||
              ret.docs[0].data().signedcontract_by === "telefone" ||
              ret.docs[0].data().signedcontract_by === "Pessoalmente"
            ) {
              msg =
                msg +
                "de <b>Callcenter</b> - Vendido por: <b>" +
                ret.docs[0].data().signedcontract_partner +
                "</b>";
            } else {
              msg = msg + "<b>Online</b>";
            }
            if (ret.docs[0].data().status) {
              msg =
                msg +
                "<br> Cliente com status: <b>" +
                ret.docs[0].data().status +
                "</b>";
            }
          }
          if (ret.docs[0].data().email !== this.email) {
            this.valid = false;
            this.snack(msg, "red", "top");
            this.cpf_duplicated = true;
            this.cpf_duplicated_msg = msg;
            return true;
          } else if (ret.docs[0].data().status !== "ONBOARDING") {
            this.valid = false;
            this.snack(msg, "red", "top");
            this.cpf_duplicated = true;
            this.cpf_duplicated_msg = msg;
            return true;
          } else {
            this.cpf_duplicated = false;
            this.cpf_duplicated_msg = "";
            return false;
          }
        } else {
          this.cpf_duplicated = false;
          this.cpf_duplicated_msg = "";
          return false;
        }
      } else {
        this.cpf_duplicated = false;
        this.cpf_duplicated_msg = "";
        return false;
      }
    },

    async validate() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        if (this.cadLead === "new" || this.old_cpf !== this.cpf) {
          if (await this.validaCPFNaBase(this.cpf)) {
            console.error("cpf já existe na base");
            this.loading = false;
            return;
          }
        }
        if (this.cupom && this.cupom.trim() !== "" && !this.disabledCupom) {
          let valida = await this.validateCupom(this.cupom.trim());
          if (!valida) {
            this.loading = false;
            return;
          }
        }
        let status = "QUALIFICAR";
        let termo_uso = "Sim";
        if (this.loggedUser.send_proposal) {
          status = "REQUEST_PROPOSAL";
          termo_uso = "Não";
        }
        let phone = formatPhone(this.phone, "+55");
        let other_phones = [];
        if (this.phones) {
          other_phones = this.phones.map((e) => {
            return {
              name: e.name,
              phone: formatPhone(e.phone, "+55"),
            };
          });
        }
        if (!this.person_type || this.person_type.trim() === "") {
          this.snack(
            "Por favor informe se é um cadsatro de PF ou PJ!",
            "red",
            "top",
          );
          return;
        }
        if (!this.selected_plan) {
          this.snack(
            "Por favor informe o Plano selecionado pelo Cliente!",
            "red",
            "top",
          );
          return;
        }

        let doc1 = null;
        let doc2 = null;
        let doc3 = null;
        let sign = null;

        //Realiza o upload da Frente do Arquivo
        if (this.docfrente) {
          this.save_btn_label = "Gravando Frente do Documento";
          await uploadDoc(this.docfrente, this.email, "id_card_photo_1.png")
            .then((res) => {
              doc1 = res;
            })
            .catch((error) => {
              console.error(
                "Erro ao realizar upload da frente do arquivo: ",
                error,
              );
            });
        }

        //Realiza o upload do Verso do Arquivo
        if (this.docverso) {
          this.save_btn_label = "Gravando Verso do Documento";
          await uploadDoc(this.docverso, this.email, "id_card_photo_2.png")
            .then((res) => {
              doc2 = res;
            })
            .catch((error) => {
              console.error(
                "Erro ao realizar upload da frente do arquivo: ",
                error,
              );
            });
        }

        //Realiza o upload do Verso do Arquivo
        if (this.docself) {
          this.save_btn_label = "Gravando Self";
          await uploadDoc(this.docself, this.email, "id_card_photo_3.png")
            .then((res) => {
              doc3 = res;
            })
            .catch((error) => {
              console.error(
                "Erro ao realizar upload da frente do arquivo: ",
                error,
              );
            });
        }
        if (this.$refs.signaturePad) {
          const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
          if (!isEmpty && data) {
            this.save_btn_label = "Gravando Assinatura";
            await uploadDoc(data, this.email, "id_card_photo_sign.png")
              .then((res) => {
                sign = {
                  path: res,
                  data: data,
                };
              })
              .catch((error) => {
                console.error(
                  "Erro ao realizar upload da frente do arquivo: ",
                  error,
                );
              });
          }
        }
        let newUser = {
          name: this.name,
          person_type: this.person_type,
          company_name: this.company_name,
          email: this.email.toLowerCase().trim() || this.email,
          phone: phone,
          other_phones:
            other_phones && other_phones.length > 0
              ? other_phones.filter((e) => e.phone != "")
              : [],
          group: "customer",
          address: {
            address: this.logradouro || "",
            address_number: this.numero || "",
            address_complement: this.complemento || "",
            district: this.bairro || "",
            postal_code: this.cep || "",
            state: this.state,
            city: this.localidade,
            country: {
              initials: "br",
              name: "Brasil",
            },
          },
          ID_document: this.rg + "-" + this.orgao_expeditor,
          average_consumption: this.average,
          cpf: this.cpf,
          password: this.cpf,
          date_of_birth: this.birthday,
          gender: this.gender,
          utility_company: this.utility_company.toUpperCase(),
          installation_number: this.consumer_unit || "",
          installation_numbers: this.ucs,
          nationality: this.nacionalidade || "brasileiro(a)",
          payment_type: this.payment_type,
          mother_name: this.mother_name || "",
          requiredPSChange: 1,
          sales_observation: this.sales_observation || "",
          created_at: new Date(),
          updated_at: new Date(),
          platform: this.platform || "super",
          unique_billing: this.payment_type === "credit_card" ? false : true,
          tabulation: this.tabulation,
          promo_code: this.indicator_email,
        };

        if (this.utility_company === "neoenergia-pe") {
          newUser.customer_numbers = this.ucs;
          delete newUser.installation_numbers;
          delete newUser.installation_number;
        }

        if (doc1) newUser.id_card_photo_1 = doc1;
        if (doc2) newUser.id_card_photo_2 = doc2;
        if (doc3) newUser.id_card_selfie = doc3;
        if (sign) newUser.id_card_signature = sign;

        if (this.person_type === "pj") {
          newUser.cpf_legal_responsible = this.cpf_legal_responsible;
          newUser.enercred_contract = this.enercred_contract;
        }

        let plan = {
          id: this.selected_plan.id,
          name: this.selected_plan.name,
          contract_time: this.selected_plan.contract_time,
          discount: this.selected_plan.discount,
        };
        plan.contract_time = this.selected_plan.contract_time;
        newUser.plan = plan;

        if (!this.user.customer_id) {
          newUser.status = status;
          newUser.termouso = termo_uso;
          newUser.signedcontract_at = new Date();
          newUser.signedcontract_by = this.signedcontract_by;
          newUser.signedcontract_source =
            this.loggedUser.partner_id || "enercred";
          newUser.signedcontract_partner = this.loggedUser
            ? this.loggedUser.email
            : null;
        }
        if (this.coupon && this.cupom) {
          newUser.coupon = this.coupon;
          if (this.coupon.type === "referral") {
            updateLead(this.email, { promo_code: this.coupon.user });
          }
        }
        if (!this.user.customer_id) {
          const history = {
            created_at: new Date(),
            user_id: this.loggedUser.email,
            action: "created",
          };
          newUser.history = [];
          newUser.history.push(history);
        } else {
          newUser.history = this.user.history || [];
          const history = {
            created_at: new Date(),
            user_id: this.loggedUser.email,
            action: "updated",
          };
          newUser.history.push(history);
        }

        storeCustomer(newUser)
          .then(async (user) => {
            if (user.status === 200 && user.data.buyer_id && user.data.id) {
              // Se o cupom possuir planta especifica qualifica com a planta correta
              let power_plant_qualification = null;
              if (this.cupom && this.coupon && this.coupon.power_plant_id)
                power_plant_qualification = this.coupon.power_plant_id;

              // Se o cupom possuir percentual de desconto persolalizado qualifica com o percentual de desconto do cupom
              let percentage_discount_qualification = null;
              if (this.cupom && this.coupon && this.coupon.percentage_discount)
                percentage_discount_qualification =
                  this.coupon.percentage_discount;

              let seller = {
                signedcontract_at: new Date().toISOString(),
                signedcontract_by: this.signedcontract_by || "SUPER",
                signedcontract_source: this.loggedUser.partner_id || "enercred",
                signedcontract_partner:
                  this.signedcontract_partner &&
                  this.signedcontract_partner !== ""
                    ? this.signedcontract_partner
                    : this.loggedUser.email,
              };

              if (this.idPhoto.data)
                await this.uploadFile(user.data.id, this.idPhoto.data);

              await finishQualification(
                this.cpf,
                user.data.id,
                this.qualification_ids,
                percentage_discount_qualification,
                null,
                power_plant_qualification,
                plan,
                seller,
                this.utility_company,
                this.agent_email,
              )
                .then((ret) => {
                  if (ret.status === 200) {
                    // Se o cliente colocou um Cupom de desconto valido, cria evento no Google Tag Manager
                    if (this.cupom && this.coupon) {
                      // Grava evento no Amplitude
                      const analytics = {
                        eventCategory: "super",
                        eventAction: "cupom",
                        eventLabel: "Cliente adicionou o cupom",
                        value: user.data.average_consumption,
                        cupom: this.coupon.coupon,
                      };
                      saveAnalytics(analytics);

                      //Marca como venda no RDStation
                      setWinOpportunity({
                        event: "SALE",
                        email: newUser.email,
                        sales_value: newUser.average_consumption,
                      })
                        .then(() => {
                          console.log(
                            "Marcado como venda realizada no RDStation",
                          );
                        })
                        .catch((err) => {
                          console.error(err);
                        });

                      // Atualiza a quantidade de uso do Cupon
                      if (this.cupom && this.coupon)
                        updateUsedCoupon(this.coupon.id);
                    }
                  } else {
                    this.snack(
                      "Erro ao finalizar qualificação. " + ret.data,
                      "warning",
                      "bottom",
                    );
                  }
                })
                .catch((err) => {
                  console.error(err);
                  this.snack(
                    `Erro ao finalizar qualificação. ${
                      err && err.response ? err.response.data : ""
                    }`,
                    "warning",
                    "bottom",
                  );
                });

              if (!this.user.customer_id) {
                if (this.cadLead === "edit") {
                  const data = {
                    signedcontract_at: new Date(),
                    signedcontract_by: this.signedcontract_by,
                    termouso: "Sim",
                    signedcontract_source:
                      this.loggedUser.partner_id || "enercred",
                    signedcontract_partner: this.loggedUser.email,
                  };
                  if (this.signedcontract_partner) {
                    data.signedcontract_partner = this.signedcontract_partner;
                    data.created_by = this.loggedUser.email;
                  }
                  updateLead(this.email, data)
                    .then(() => {
                      return;
                    })
                    .catch((err) => {
                      console.error("Erro ao criar lead: ", err);
                    });
                } else {
                  addLead(newUser)
                    .then(() => {
                      return;
                    })
                    .catch((err) => {
                      console.error("Erro ao criar lead: ", err);
                    });
                }
                if (this.ucs.length > 0) {
                  this.ucs.map((uc) => {
                    const analytics = {
                      eventCategory: "NOVO",
                      eventAction: "SUBSCRIPTION",
                      eventLabel: this.loggedUser.partner_id || "enercred",
                      transaction_id: user.data.email,
                      value: user.data.average_consumption,
                      utm_source: this.utm_source || "SUPER",
                      utm_medium: this.utm_medium || this.signedcontract_by,
                      utm_campaign: this.utm_campaign || "",
                      utm_content: this.utm_content || "",
                      utm_term: this.utm_term || "",
                      boleto: true,
                      uc: uc.text,
                    };
                    saveAnalytics(analytics);
                  });
                } else {
                  const analytics = {
                    eventCategory: "NOVO",
                    eventAction: "SUBSCRIPTION",
                    eventLabel: this.loggedUser.partner_id || "enercred",
                    transaction_id: user.data.email,
                    value: user.data.average_consumption,
                    utm_source: "SUPER",
                    utm_medium: this.signedcontract_by,
                    utm_campaign: this.loggedUser.email,
                    boleto: true,
                    uc: "não informado",
                  };
                  saveAnalytics(analytics);
                }
              } else {
                if (newUser.signedcontract_at) {
                  if (this.ucs.length > 0) {
                    this.ucs.map((uc) => {
                      const analytics = {
                        eventCategory: "NOVO",
                        eventAction: "SUBSCRIPTION",
                        eventLabel: this.loggedUser.partner_id || "enercred",
                        transaction_id: user.data.email,
                        value: user.data.average_consumption,
                        utm_source: "SUPER",
                        utm_medium: this.signedcontract_by,
                        utm_campaign: this.loggedUser.email,
                        boleto: true,
                        uc: uc.text,
                      };
                      saveAnalytics(analytics);
                    });
                  } else {
                    const analytics = {
                      eventCategory: "NOVO",
                      eventAction: "SUBSCRIPTION",
                      eventLabel: this.loggedUser.partner_id || "enercred",
                      transaction_id: user.data.email,
                      value: user.data.average_consumption,
                      utm_source: "SUPER",
                      utm_medium: this.signedcontract_by,
                      utm_campaign: this.loggedUser.email,
                      boleto: true,
                      uc: "não informado",
                    };
                    saveAnalytics(analytics);
                  }
                }
              }
              this.user = user.data;
              this.lead.user = user.data;
              eventBus.$emit("Lead", this.lead);

              let conversion = {
                event_type: "SALE",
                event_family: "CDP",
                payload: {
                  email: user.data.email,
                  funnel_name: "default",
                  value: 200,
                },
              };

              if (conversion.event_type) {
                this.$apollo.mutate({
                  // Query
                  mutation: SET_CONVERSION,
                  // Parameters
                  variables: {
                    event_type: conversion.event_type,
                    event_family: conversion.event_family,
                    payload: conversion.payload,
                  },
                });
              }

              //Cadastra evento Offline no facebook
              const valor = newUser.name.split(" ");
              let nome = valor.shift();
              let sobrenome = valor.join(" ");
              let fb_data = {
                email: newUser.email,
                fn: nome || newUser.name,
                ln: sobrenome || newUser.name,
                phone: phone,
                gen: newUser.gender,
                extern_id: user.data.id,
                lead_id: newUser.email,
                value: newUser.average_consumption || 250,
                currency: "BRL",
                customer_id: user.data.id,
              };
              if (newUser.address && newUser.address.city)
                fb_data.ct = newUser.address.city;
              if (newUser.address && newUser.address.postal_code)
                fb_data.zip = newUser.address.postal_code;

              setFbEvent(fb_data, "inside_sale", "Purchase");
              this.snack("Venda realizada com sucesso!", "green", "top");
            }
            this.destroyed();
            this.loading = false;
          })
          .catch((error) => {
            console.error("Erro ao realizar venda!", error.message);
            let err_msg = "Erro ao gravar membro! Contate nosso suporte.";
            if (error.code === "auth/email-already-in-use") {
              err_msg = "Este email está sendo utilizado por outra conta.";
            }
            this.snack(err_msg + " - " + error, "red", "top");
            this.loading = false;
          });
      }
    },

    async reSubscription() {
      if (this.$refs.form.validate()) {
        if (this.cupom && this.cupom.trim() !== "" && !this.disabledCupom) {
          let valida = await this.validateCupom(this.cupom.trim());
          if (!valida) {
            this.loading = false;
            return;
          }
        }
        let status = "QUALIFICAR";
        this.loading = true;
        let _canSubscription = await this.canSubscription(this.user);
        if (!_canSubscription) {
          console.error(
            "Membro com contrato assinado ou em processo de assinatura não pode ser revendido!",
          );
          this.snack(
            "Membro com contrato assinado ou em processo de assinatura não pode ser revendido!",
            "red",
            "top",
          );
        }
        let phone = formatPhone(this.phone, "+55");
        let other_phones;
        if (this.phones) {
          other_phones = this.phones.map((e) => {
            return {
              name: e.name,
              phone: formatPhone(e.phone, "+55"),
            };
          });
        }
        if (!this.person_type || this.person_type.trim() === "") {
          this.snack(
            "Por favor informe se é um cadsatro de PF ou PJ!",
            "red",
            "top",
          );
          return;
        }
        if (!this.selected_plan) {
          this.snack(
            "Por favor informe o Plano selecionado pelo Cliente!",
            "red",
            "top",
          );
          return;
        }
        let newUser = {
          name: this.name,
          person_type: this.person_type,
          company_name: this.company_name,
          email: this.email.toLowerCase().trim() || this.email,
          phone: phone,
          other_phones:
            other_phones && other_phones.length > 0
              ? other_phones.filter((e) => e.phone != "")
              : [],
          group: "customer",
          address: {
            address: this.logradouro || "",
            address_number: this.numero || "",
            address_complement: this.complemento || "",
            district: this.bairro || "",
            postal_code: this.cep || "",
            state: this.state,
            city: this.localidade,
            country: {
              initials: "br",
              name: "Brasil",
            },
          },
          ID_document: this.rg + "-" + this.orgao_expeditor,
          average_consumption: this.average || "",
          cpf: this.cpf,
          password: this.cpf,
          date_of_birth: this.birthday,
          gender: this.gender,
          installation_number: this.consumer_unit,
          installation_numbers: this.ucs,
          nationality: this.nacionalidade || "brasileiro(a)",
          payment_type: this.payment_type,
          mother_name: this.mother_name || "",
          requiredPSChange: 1,
          sales_observation: this.sales_observation || null,
          unique_billing: this.payment_type === "credit_card" ? false : true,
          platform: this.platform || "super",
          tabulation: this.tabulation,
          utility_company: this.utility_company.toUpperCase(),
          promo_code: this.indicator_email,
        };

        if (this.utility_company === "neoenergia-pe") {
          newUser.customer_numbers = this.ucs;
          delete newUser.installation_numbers;
          delete newUser.installation_number;
        }

        newUser.status = status;
        newUser.signedcontract_at = new Date().toISOString();
        newUser.signedcontract_by = this.signedcontract_by;
        newUser.signedcontract_source =
          this.loggedUser.partner_id || "enercred";
        newUser.signedcontract_partner = this.loggedUser
          ? this.loggedUser.email
          : null;

        if (this.person_type === "pj") {
          newUser.cpf_legal_responsible = this.cpf_legal_responsible;
          newUser.enercred_contract = this.enercred_contract;
        }
        let plan = {
          id: this.selected_plan.id,
          name: this.selected_plan.name,
          contract_time: this.selected_plan.contract_time,
          discount: this.selected_plan.discount,
        };
        plan.contract_time = this.selected_plan.contract_time;
        newUser.plan = plan;
        if (this.coupon && this.cupom) {
          newUser.coupon = this.coupon;
          if (this.coupon.type === "referral") {
            updateLead(this.email, { promo_code: this.coupon.user });
          }
        }

        //Grava vendedor anterior
        let old_sellers = this.user.old_sellers || [];
        if (this.user.signedcontract_partner) {
          let object = {
            status: this.user.status,
            signedcontract_at: this.user.signedcontract_at,
            signedcontract_by: this.user.signedcontract_by,
            signedcontract_source: this.user.signedcontract_source,
            signedcontract_partner: this.user.signedcontract_partner,
          };
          if (this.signedcontract_partner) {
            object.signedcontract_partner = this.signedcontract_partner;
            object.created_by = this.loggedUser.email;
          }

          old_sellers.push(object);
          newUser.old_sellers = old_sellers;
        }
        if (!this.user.customer_id) {
          const history = {
            created_at: new Date(),
            user_id: this.loggedUser.email,
            action: "created",
          };
          newUser.history = [];
          newUser.history.push(history);
        } else {
          newUser.history = this.user.history || [];
          const history = {
            created_at: new Date(),
            user_id: this.loggedUser.email,
            action: "updated",
          };
          newUser.history.push(history);
        }
        updateUser(this.user.customer_id, newUser)
          .then(async (user) => {
            // Se o cupom possuir planta especifica qualifica com a planta correta
            let power_plant_qualification = null;
            if (this.cupom && this.coupon && this.coupon.power_plant_id)
              power_plant_qualification = this.coupon.power_plant_id;

            // Se o cupom possuir percentual de desconto persolalizado qualifica com o percentual de desconto do cupom
            let percentage_discount_qualification = null;
            if (this.cupom && this.coupon && this.coupon.percentage_discount)
              percentage_discount_qualification =
                this.coupon.percentage_discount;

            let seller = {
              signedcontract_at: new Date().toISOString(),
              signedcontract_by: this.signedcontract_by || "SUPER",
              signedcontract_source: this.loggedUser.partner_id || "enercred",
              signedcontract_partner:
                this.signedcontract_partner &&
                this.signedcontract_partner !== ""
                  ? this.signedcontract_partner
                  : this.loggedUser.email,
            };

            await finishQualification(
              this.cpf,
              this.user.customer_id,
              this.qualification_ids,
              percentage_discount_qualification,
              null,
              power_plant_qualification,
              plan,
              seller,
              this.utility_company,
              this.agent_email,
            )
              .then((ret) => {
                if (ret.status === 200) {
                  console.log("Qualificação finalizada");
                  if (this.cupom && this.coupon) {
                    // Grava evento no Amplitude
                    const analytics = {
                      eventCategory: "super",
                      eventAction: "cupom",
                      eventLabel: "Cliente adicionou o cupom",
                      value: user.data.average_consumption,
                      cupom: this.coupon.coupon,
                    };
                    saveAnalytics(analytics);

                    // Atualiza a quantidade de uso do Cupon
                    if (this.cupom && this.coupon)
                      updateUsedCoupon(this.coupon.id);
                  }
                } else {
                  this.snack(
                    "Erro ao finalizar qualificação. " + ret.data,
                    "warning",
                    "bottom",
                  );
                }
              })
              .catch((err) => {
                console.error(err);
                this.snack(
                  `Erro ao finalizar qualificação. ${
                    err && err.response ? err.response.data : ""
                  }`,
                  "warning",
                  "bottom",
                );
              });
            if (this.cadLead === "edit") {
              const data = {
                signedcontract_at: new Date(),
                signedcontract_by: this.signedcontract_by,
                termouso: "Sim",
                signedcontract_source: this.loggedUser.partner_id || "enercred",
                signedcontract_partner: this.loggedUser.email,
              };
              if (
                this.signedcontract_partner &&
                this.signedcontract_partner !== ""
              ) {
                data.signedcontract_partner = this.signedcontract_partner;
                data.created_by = this.loggedUser.email;
              }
              updateLead(this.email, data)
                .then(() => {
                  return;
                })
                .catch((err) => {
                  console.error("Erro ao criar lead: ", err);
                });
            } else {
              addLead(newUser)
                .then(() => {
                  return;
                })
                .catch((err) => {
                  console.error("Erro ao criar lead: ", err);
                });
            }
            if (this.ucs.length > 0) {
              this.ucs.map((uc) => {
                const analytics = {
                  eventCategory: "REVENDA",
                  eventAction: "SUBSCRIPTION",
                  eventLabel: this.loggedUser.partner_id || "enercred",
                  transaction_id: user.data.email,
                  value: user.data.average_consumption,
                  utm_source: "SUPER",
                  utm_medium: this.signedcontract_by,
                  utm_campaign: this.loggedUser.email,
                  boleto: true,
                  uc: uc.text,
                };
                saveAnalytics(analytics);
              });
            } else {
              const analytics = {
                eventCategory: "REVENDA",
                eventAction: "SUBSCRIPTION",
                eventLabel: this.loggedUser.partner_id || "enercred",
                transaction_id: user.data.email,
                value: user.data.average_consumption,
                utm_source: "SUPER",
                utm_medium: this.signedcontract_by,
                utm_campaign: this.loggedUser.email,
                boleto: true,
                uc: "não informado",
              };
              saveAnalytics(analytics);
            }

            this.user = user.data;
            this.lead.user = user.data;
            eventBus.$emit("Lead", this.lead);

            let conversion = {
              event_type: "SALE",
              event_family: "CDP",
              payload: {
                email: user.data.email,
                funnel_name: "default",
                value: 200,
              },
            };

            if (conversion.event_type) {
              this.$apollo.mutate({
                // Query
                mutation: SET_CONVERSION,
                // Parameters
                variables: {
                  event_type: conversion.event_type,
                  event_family: conversion.event_family,
                  payload: conversion.payload,
                },
              });
            }

            //Cadastra evento Offline no facebook
            const valor = newUser.name.split(" ");
            let nome = valor.shift();
            let sobrenome = valor.join(" ");
            let fb_data = {
              email: newUser.email,
              fn: nome || newUser.name,
              ln: sobrenome || newUser.name,
              phone: phone,
              gen: newUser.gender,
              extern_id: user.data.id,
              lead_id: newUser.email,
              value: newUser.average_consumption || 250,
              currency: "BRL",
              customer_id: user.data.id,
            };
            if (newUser.address && newUser.address.city)
              fb_data.ct = newUser.address.city;
            if (newUser.address && newUser.address.postal_code)
              fb_data.zip = newUser.address.postal_code;

            setFbEvent(fb_data, "inside_sale", "Purchase");
            this.snack("Vendas realizada com sucesso!", "green", "top");
            this.loading = false;
          })
          .catch((error) => {
            console.error("Erro ao realizar venda!", error.message);
            let err_msg = "Erro ao gravar membro! Contate nosso suporte.";
            if (error.code === "auth/email-already-in-use") {
              err_msg = "Este email está sendo utilizado por outra conta.";
            }
            this.snack(err_msg + " - " + error, "red", "top");
            this.loading = false;
          });
      }
    },

    async save() {
      try {
        this.loading = true;
        this.save_btn_label = "Salvando Lead...";
        console.log("Salvando Lead...");

        if (!this.name || this.name.trim() === "") {
          this.snack("Por favor preencha o nome do membro!", "red", "top");
          this.loading = false;
          return;
        }
        if (!this.email || this.email.trim() === "") {
          this.loading = false;
          this.snack("Por favor preencha o email do membro!", "red", "top");
          return;
        }
        if (!this.status_lead || this.status_lead.trim() === "") {
          this.snack(
            "Por favor preencha a ação que deve ser feita ao lead!",
            "red",
            "top",
          );
          this.loading = false;
          return;
        }
        if (!this.person_type || this.person_type.trim() === "") {
          this.snack(
            "Por favor informe se é um cadsatro de PF ou PJ!",
            "red",
            "top",
          );
          this.loading = false;
          return;
        }

        if (!this.utility_company || this.utility_company.trim() === "") {
          this.snack(
            "Por favor informe a concessionária do Cliente!",
            "red",
            "top",
          );
          this.loading = false;
          return;
        }

        if (!this.tabulation) {
          this.snack(
            "Por favor preencha a tabulação antes de salvar esse Lead!",
            "red",
            "top",
          );
          this.loading = false;
          return;
        }

        if (this.cpf && (this.cadLead === "new" || this.old_cpf !== this.cpf)) {
          if (await this.validaCPFNaBase(this.cpf)) {
            console.error("cpf já existe na base");
            this.loading = false;
            return;
          }
        }
        if (this.user.customer_id) {
          let _canSubscription = await this.canSubscription(this.user);
          if (!_canSubscription) {
            console.error(
              "Membro com contrato assinado ou em processo de assinatura não pode ser revendido!",
            );
            this.snack(
              "Membro com contrato assinado ou em processo de assinatura não pode ser revendido!",
              "red",
              "top",
            );
            this.loading = false;
          }
        }
        console.log("Inicia criacao do documento no firebase");
        let status = this.status_lead !== "Trabalhar" ? "NO_INTEREST" : "SAVED";
        if (this.is_disqualification) status = "DESQUALIFICAR";
        let phone = formatPhone(this.phone, "+55");
        let other_phones;
        if (this.phones) {
          other_phones = this.phones.map((e) => {
            return {
              name: e.name,
              phone: formatPhone(e.phone, "+55"),
            };
          });
        }

        let finished = false;
        if (this.tabulation.finishLead) finished = true;

        let newUser = {
          name: this.name,
          person_type: this.person_type,
          company_name: this.company_name,
          email: this.email.toLowerCase().trim() || this.email,
          phone: phone,
          other_phones:
            other_phones && other_phones.length > 0
              ? other_phones.filter((e) => e.phone != "")
              : [],
          group: "customer",
          address: {
            address: this.logradouro || "",
            address_number: this.numero || "",
            address_complement: this.complemento || "",
            district: this.bairro || "",
            postal_code: this.cep || "",
            state: this.state,
            city: this.localidade,
            country: {
              initials: "br",
              name: "Brasil",
            },
          },
          ID_document: this.rg + "-" + this.orgao_expeditor,
          average_consumption: this.average,
          cpf: this.cpf,
          password: this.cpf,
          date_of_birth: this.birthday,
          gender: this.gender,
          utility_company: this.utility_company.toUpperCase(),
          installation_number: this.consumer_unit || "",
          installation_numbers: this.ucs,
          nationality: this.nacionalidade || "brasileiro(a)",
          payment_type: this.payment_type,
          mother_name: this.mother_name || "",
          requiredPSChange: 1,
          sales_observation: this.sales_observation || null,
          updated_at: new Date(),
          unique_billing: this.payment_type === "credit_card" ? false : true,
          platform: this.platform || "super",
          tabulation: this.tabulation ? this.tabulation.id : null,
          promo_code: this.indicator_email,
          finished: finished,
        };

        if (this.utility_company === "neoenergia-pe") {
          newUser.customer_numbers = this.ucs;
          delete newUser.installation_numbers;
          delete newUser.installation_number;
        }

        if (this.person_type === "pj") {
          newUser.cpf_legal_responsible = this.cpf_legal_responsible;
          newUser.enercred_contract = this.enercred_contract;
        }
        if (this.selected_plan && this.selected_plan.id) {
          let plan = {
            id: this.selected_plan.id,
            name: this.selected_plan.name,
            contract_time: this.selected_plan.contract_time,
            discount: this.selected_plan.discount,
          };
          plan.contract_time = this.selected_plan.contract_time;
          newUser.plan = plan;
        }

        if (this.coupon && this.cupom) {
          newUser.coupon = this.coupon;
          if (this.coupon.discount) {
            newUser.account_balance = this.coupon.discount;
          }
        }
        // Salvar
        newUser.status = status;
        newUser.saved_at = new Date();
        newUser.saved_by = "SUPER";
        newUser.saved_source = this.loggedUser.partner_id || "enercred";
        newUser.saved_partner = this.loggedUser.email;

        //Salva lead
        if (this.cadLead === "edit") {
          const newLead = {
            ...newUser,
            user: newUser,
            status: status,
            updated_at: new Date(),
            send_simulate: true,
          };
          updateLead(this.email, newLead)
            .then(() => {
              this.snack("Lead gravado com sucesso!", "green", "top");
              this.loading = false;
            })
            .catch((err) => {
              this.snack(
                "Houve um erro inesperado. Procure nosso suporte!",
                "red",
                "top",
              );
              console.error("Erro ao criar lead: ", err);
              this.loading = false;
            });
        } else {
          newUser.created_at = new Date();
          newUser.updated_at = new Date();
          newUser.send_simulate = true;
          addLead(newUser)
            .then(() => {
              this.snack("Lead gravado com sucesso!", "green", "top");
              this.loading = false;
              const analytics = {
                eventCategory: "SUPER",
                eventAction: "LEADS-TRABALHADOS",
                eventLabel: this.loggedUser.partner_id || "enercred",
                transaction_id: newUser.email,
                value: newUser.average_consumption,
                utm_source: "SUPER",
                utm_medium: this.signedcontract_by || "",
                utm_campaign: this.loggedUser.email,
                boleto: true,
                uc: "não informado",
              };
              saveAnalytics(analytics);
            })
            .catch((err) => {
              this.snack(
                "Houve um erro inesperado. Procure nosso suporte!",
                "red",
                "top",
              );
              console.error("Erro ao criar lead: ", err);
              this.loading = false;
              const analytics = {
                eventCategory: "SUPER",
                eventAction: "LEADS-TRABALHADOS",
                eventLabel: this.loggedUser.partner_id || "enercred",
                transaction_id: newUser.email,
                value: newUser.average_consumption,
                utm_source: "SUPER",
                utm_medium: this.signedcontract_by,
                utm_campaign: this.loggedUser.email,
                boleto: true,
                uc: "não informado",
              };
              saveAnalytics(analytics);
            });
        }
      } catch (error) {
        console.error(error);
        this.snack(
          "Houve um erro inesperado. Procure nosso suporte!",
          "red",
          "top",
        );
        this.loading = false;
      }
    },

    async addUcs() {
      // Se o cupom possuir planta especifica qualifica com a planta correta
      let power_plant_qualification = null;
      if (this.cupom && this.coupon && this.coupon.power_plant_id)
        power_plant_qualification = this.coupon.power_plant_id;

      // Se o cupom possuir percentual de desconto persolalizado qualifica com o percentual de desconto do cupom
      let percentage_discount_qualification = null;
      if (this.cupom && this.coupon && this.coupon.percentage_discount)
        percentage_discount_qualification = this.coupon.percentage_discount;

      let seller = {
        signedcontract_at: new Date().toISOString(),
        signedcontract_by: this.signedcontract_by || "SUPER",
        signedcontract_source: this.loggedUser.partner_id || "enercred",
        signedcontract_partner:
          this.signedcontract_partner && this.signedcontract_partner !== ""
            ? this.signedcontract_partner
            : this.loggedUser.email,
      };

      let plan = {
        id: this.selected_plan.id,
        name: this.selected_plan.name,
        contract_time: this.selected_plan.contract_time,
        discount: this.selected_plan.discount,
      };
      plan.contract_time = this.selected_plan.contract_time;

      if (!this.user.signedcontract_by) {
        let data = {
          ...seller,
          termouso: "Sim",
          updated_at: new Date(),
          plan: plan,
        };
        updateUser(this.user.customer_id, data);
      }

      await finishQualification(
        this.cpf,
        this.user.customer_id,
        this.qualification_ids,
        percentage_discount_qualification,
        null,
        power_plant_qualification,
        plan,
        seller,
        this.utility_company,
        this.agent_email,
      )
        .then((ret) => {
          if (ret.status === 200) {
            console.log("Qualificação finalizada");
            if (this.cupom && this.coupon) {
              // Grava evento no Amplitude
              const analytics = {
                eventCategory: "super",
                eventAction: "cupom",
                eventLabel: "Cliente adicionou o cupom",
                value: this.average,
                cupom: this.coupon.coupon,
              };
              saveAnalytics(analytics);

              // Atualiza a quantidade de uso do Cupon
              if (this.cupom && this.coupon) updateUsedCoupon(this.coupon.id);
            }
          } else {
            this.snack(
              "Erro ao finalizar qualificação. " + ret.data,
              "warning",
              "bottom",
            );
          }
        })
        .catch((err) => {
          console.error(err);
          this.snack(
            `Erro ao finalizar qualificação. ${
              err && err.response ? err.response.data : ""
            }`,
            "warning",
            "bottom",
          );
        });

      //Cadastra evento Offline no facebook
      const valor = this.user.name.split(" ");
      let nome = valor.shift();
      let sobrenome = valor.join(" ");
      let fb_data = {
        email: this.user.email,
        fn: nome || this.user.name,
        ln: sobrenome || this.user.name,
        phone: this.user.phone,
        gen: this.user.gender,
        extern_id: this.user.id,
        lead_id: this.user.email,
        value: this.user.average_consumption || 250,
        currency: "BRL",
        customer_id: this.user.id,
      };
      if (this.user.address && this.user.address.city)
        fb_data.ct = this.user.address.city;
      if (this.user.address && this.user.address.postal_code)
        fb_data.zip = this.user.address.postal_code;

      setFbEvent(fb_data, "inside_sale", "Purchase");
      this.snack("Unidades Adicionadas com sucesso!", "green", "top");
      this.loading = false;
    },

    async canSubscription(user) {
      if (!user.customer_id) return true;
      if (
        user.signedcontract_by === "onboarding" &&
        user.signedcontract_source === "online" &&
        user.signedcontract_partner === "enercred" &&
        user.status === "ATIVO"
      )
        return false;
      let args = {
        searchBy: {
          field: "user_id",
          operator: "==",
          value: user.customer_id,
        },
      };
      let ucs = await getConsumerUnits(args).get();

      let contract_id = 0;
      contract_id = await ucs.docs.reduce(async (sum, cur) => {
        console.log(
          "validacao1: ",
          (cur.data().contract_id &&
            cur.data().contract_id !== "" &&
            cur.data().status !== "contract_not_signed" &&
            cur.data().status !== "canceled") ||
            cur.data().billing_competence_start,
        );
        if (cur.data().status === "canceled") {
          // Verifica se há pendencias financeiras // Se não houver deve permitir a revenda com consentimento
          // Busca pendencias financeiras
          let billings = await getBillingsByUserOpened(user.id);
          if (billings.size > 0) return sum++;
        }
        if (
          (cur.data().contract_id &&
            cur.data().contract_id !== "" &&
            cur.data().status !== "contract_not_signed" &&
            cur.data().status !== "canceled") ||
          cur.data().billing_competence_start
        ) {
          sum++;
          return sum;
        } else return sum;
      }, 0);
      if (
        user.signedcontract_by === "mobile_app" &&
        contract_id > 0 &&
        user.status === "ATIVO"
      ) {
        console.error(
          "Clientes que fizeram assinatura por app não podem ser revendidos",
        );
        return false;
      }

      return contract_id <= 0;
    },

    async hasSubscription(user) {
      if (!user.customer_id) return true;
      let args = {
        searchBy: {
          field: "user_id",
          operator: "==",
          value: user.customer_id,
        },
      };
      let ucs = await getConsumerUnits(args).get();

      if (ucs.size > 0) {
        let _ucs = [];
        for (let i = 0; i < ucs.size; i++) {
          _ucs.push({ id: ucs.docs[i].id, ...ucs.docs[i].data() });
        }

        let billings = await getBillingsByUserOpened(user.id);
        if (billings && billings.size > 0) {
          return { error: true, msg: "Cliente possui pendências Financeiras" };
        }
        return {
          items: _ucs,
        };
      } else {
        return null;
      }
    },

    getPSeller() {
      getPartnerSellers()
        .then((psellers) => {
          this.psellers = psellers.docs.map((u) => {
            return {
              id: u.id,
              ...u.data(),
            };
          });
        })
        .catch((err) => console.error(err));
    },

    reverseDate(date) {
      if (!date || date === "") return "";
      if (typeof date !== "string") {
        return moment.utc(new Date(date)).format("DD/MM/YYYY");
      } else {
        let ano = date.split("/")[2];
        let _ano = date.split("-")[0];

        if (_ano && _ano.length <= 4) {
          let dia = "";
          if (date.split("-")[2]) {
            dia = date.split("-")[2].substring(0, 2);
          }
          let mes = date.split("-")[1];
          return dia + mes + _ano;
        } else if (ano && ano.length <= 4) {
          let dia = "";
          if (date.split("/")[0]) {
            dia = date.split("/")[0].substring(0, 2);
          }
          let mes = date.split("/")[1];
          return dia + mes + ano;
        }
        return date;
      }
    },

    validateCupom(cupom) {
      this.loadingCupom = true;
      if (!cupom || cupom.trim() === "") {
        this.loadingCupom = false;
        this.isValidCoupon = true;
        return true;
      }
      return this.getCoupons(cupom)
        .then((res) => {
          if (res.status && this.coupon?.plan_id) {
            this.getPlansByParams({
              person_type: this.person_type,
              plan_id: this.coupon.plan_id + this.person_type,
            });
          }
          this.isValidCoupon = res.status;
          this.couponMessage =
            res.message === "Ok" ? "Cupom aplicado com sucesso!" : res.message;
          this.loadingCupom = false;
          this.disabledCupom = true;
          this.selected_plan = undefined;
          return res.status;
        })
        .catch((err) => {
          console.error(err);
          this.isValidCoupon = false;
          this.couponMessage = err.message;
          this.loadingCupom = false;
          this.valid = false;
          return false;
        });
    },

    clearCupom() {
      this.isValidCoupon = true;
      this.couponMessage = null;
    },

    uppercaseCoupon() {
      this.cupom = this.cupom ? this.cupom.toUpperCase() : "";
    },

    pickIdPhoto() {
      this.$refs.idPhoto.click();
    },

    async pickedPhotos(event) {
      const photosFiles = event.target.files;
      for (let i = 0; i < photosFiles.length; i++) {
        if (photosFiles[i] !== undefined) {
          let extension = photosFiles[i].name.split(".")[1].toLowerCase();
          if (!this.availableFormats.includes(extension)) {
            this.snack("O arquivo deve ser PDF, PNG, JPG ou JPEG!", "red");
            return;
          }
          if (i === photosFiles.length - 1)
            this.idPhoto.name += photosFiles[i].name;
          else this.idPhoto.name += photosFiles[i].name + ", ";
        }
      }
      this.idPhoto.data = [...photosFiles];
    },

    removeFile(typeFile) {
      typeFile.name = "";
      typeFile.data = null;
    },

    async uploadFile(userId, fileData) {
      const data = {
        id: userId,
        data: fileData,
      };
      await uploadData(data);
      this.snack("Arquivos enviados com sucesso!", "green");
    },
  },
};
</script>

<style>
#signature {
  border: double 3px transparent;
  border-radius: 5px;
  background-image:
    linear-gradient(white, white),
    radial-gradient(circle at top left, #4bc5e8, #9f6274);
  background-origin: border-box;
  background-clip: content-box, border-box;
}

.container {
  width: "100%";
  padding: 8px 16px;
}

.buttons {
  display: flex;
  gap: 8px;
  justify-content: center;
  margin-top: 8px;
}
</style>
